import type { ILang } from '@core/interfaces/ILang';

const lang: ILang = {
  alert: {
    abort: 'Cancelar',
    buy: 'Comprar',
    cancel: 'Cancelar',
    caption: 'Error',
    close: 'Cerrar',
    confirm: 'Confirmar',
    dont_save: 'No guardar',
    dont_show_again: 'No volver a mostrar',
    duplicated_preset_name: 'Duplicado del nombre preestablecido',
    error: 'UH-OH',
    info: 'INFO',
    instruction: 'Instrucción',
    learn_more: 'Más información',
    no: 'No',
    ok: 'OK',
    ok2: 'OK',
    oops: 'Vaya...',
    retry: 'Reintentar',
    save: 'Guardar',
    stop: 'Detener',
    warning: 'ADVERTENCIA',
    yes: 'Sí',
  },
  auto_fit: {
    artwork_size: 'Tamaño del diseño',
    error_tip1: '1. ¿Está colocado el diseño correctamente sobre el material?',
    error_tip2: '2. ¿Los contornos del material son suficientemente claros para poder reconocerlos?',
    failed_to_find_contour: 'No se han encontrado contornos para un ajuste automático',
    learn_more: 'Ver tutorial.',
    learn_more_url: 'https://support.flux3dp.com/hc/en-us/articles/10273384373775',
    offset_x: 'Desviación X',
    offset_y: 'Desviación Y',
    pattern_size: 'Tamaño del patrón',
    position_artwork: 'Posicionar el diseño',
    position_step1: 'Ajuste el tamaño y la posición de su diseño en el patrón.',
    position_step2: 'Pulse en "Aplicar" para aplicar el ajuste automático a este patrón.',
    preview_first: 'Por favor, realice primero la vista previa de la cámara.',
    reset_position: 'Restablecer posición',
    rotation: 'Rotar',
    select_a_pattern: 'Seleccionar un patrón',
    selected_artwork: 'Diseño seleccionado',
    step1: 'Elija un patrón donde desee colocar el diseño.',
    step2: 'Si no encuentra un patrón, vuelva a vista previa de la cámara y aplique el ajuste automático.',
    step3: 'Si sigue sin encontrar el patrón correcto, asegúrese de que el trabajo sea claramente reconocible y que el área de trabajo esté limpio de residuos.',
    title: 'Ajuste automático',
  },
  barcode_generator: {
    bar_height: 'Altura de barra',
    bar_width: 'Ancho de barra',
    barcode: {
      invalid_value: 'El valor no es válido para el formato seleccionado.',
    },
    font: 'Fuente',
    font_size: 'Tamaño de la fuente',
    hide_text: 'Ocultar texto',
    invert_color: 'Invertir color',
    text_margin: 'Margen del texto',
  },
  beambox: {
    ai_generate: {
      dimensions: {
        more: 'Más',
        ratio: 'Proporción',
        resolution: 'Resolución',
        title: 'Dimensiones de imagen',
      },
      error: {
        config_description: 'Error al cargar la configuración de IA',
        config_message: 'Error al cargar los estilos de IA',
        generation_failed: 'Error en la generación',
        import_failed: 'Error en la importación',
        insufficient_credits: 'Créditos insuficientes',
      },
      form: {
        count: 'Cantidad',
        credit_required: 'Créditos requeridos',
        editor: 'Editor',
        generate: 'Generar',
        laser_friendly: 'Compatible con láser',
      },
      header: {
        history_tooltip: 'Historial',
        reset_tooltip: 'Restablecer todo',
        title: 'Creación IA',
      },
      history: {
        detail: 'Detalle',
        empty_description: 'Aún no hay historial de generación. ¡Comienza a crear!',
        error_message: 'Error al cargar el historial',
        not_generated: '❌ No generado',
        recreate: 'Recrear',
        status_failed: 'Fallido',
        status_generating: 'Generando',
        status_success: 'Exitoso',
        storage_notice: 'Se guardan hasta 10 registros recientes. Las imágenes generadas se conservan durante 3 días.',
        title: 'Historial de generación',
      },
      loading: {
        history: 'Cargando historial...',
        styles: 'Cargando estilos de IA...',
        tip_0: 'Iniciando el motor creativo…',
        tip_1: 'Puliendo píxeles… ✨',
        tip_2: 'Casi listo, refinando los detalles',
        tip_3: 'Aún trabajando, esta parte necesita un poco más de tiempo',
        tip_4: 'Las grandes ideas toman tiempo, gracias por esperar',
      },
      results: {
        download: 'Descargar',
        import: 'Importar',
        title: 'Resultados',
      },
      retry: 'Reintentar',
      style: {
        apply: 'Aplicar estilo',
        choose: 'Elegir estilo',
        custom_creation: 'Creación personalizada',
        customize: 'Personalizar',
        select: 'Seleccionar estilo de creación',
      },
      upload: {
        add: 'Agregar',
        click_or_drag: 'Haz clic o arrastra imágenes aquí',
        error: 'Error de carga',
        file_size_error: '%s: El tamaño del archivo debe ser menor a %sMB',
        file_type_error: '%s: Solo se admiten imágenes JPEG, PNG y WebP',
        from_history: 'Desde el historial',
        images: 'Subir imágenes',
        max_images_error: 'Máximo %s imágenes permitidas',
        selected: '%s / %s seleccionado(s)',
        supported_formats: 'JPEG, PNG, WebP • Máx %s',
      },
      validation: {
        description_or_image_required: 'Por favor, proporciona una descripción o sube al menos una imagen',
        field_exceeds_max_length: '"%s" excede la longitud máxima de %s caracteres.',
        field_required: '"%s" es requerido. Por favor, completa este campo.',
        login_required: 'Por favor, inicia sesión para usar la generación de IA.',
        max_images: 'Máximo %s imágenes permitidas',
      },
    },
    announcement_panel: {
      title: 'Anuncio',
    },
    banner: {
      auto_feeder: 'Modo de alimentador automático',
      autofocus1: 'Modo de enfoque automático',
      autofocus2: 'Pulse en cualquier lugar para realizar el enfoque automático.',
      camera_preview_borderless_mode: '(Fondo abierto)',
      curve_engraving: 'Modo de grabado de curvas',
      pass_through: 'Modo de paso directo',
      rotary: 'Modo rotativo',
    },
    bottom_right_panel: {
      convert_text_to_path_before_export: 'Convertir texto en trayectoria...',
      export_file_error_ask_for_upload: 'No se ha podido exportar el trabajo. ¿Desea proporcionar una imagen al equipo de desarrollo para que pueda informar del error?',
      retreive_image_data: 'Recuperar datos de la imagen...',
    },
    context_menu: {
      copy: 'Copiar',
      cut: 'Cortar',
      delete: 'Eliminar',
      duplicate: 'Duplicar',
      group: 'Agrupar',
      move_back: 'Enviar al fondo',
      move_down: 'Enviar atrás',
      move_front: 'Traer al frente',
      move_up: 'Adelantar',
      paste: 'Pegar',
      paste_in_place: 'Pegar en su lugar',
      ungroup: 'Desagrupar',
    },
    document_panel: {
      add_on: 'Complementos',
      auto_feeder: 'Alimentador automático',
      auto_feeder_url: 'https://support.flux3dp.com/hc/en-us/articles/11688230498575',
      auto_shrink: 'Reducción automática',
      auto_shrink_tooltip: 'Solo se aplica a capas con una resolución mayor o igual a 250 DPI.',
      auto_shrink_url: 'https://support.flux3dp.com/hc/en-us/articles/12997377035919',
      borderless_mode: 'Fondo abierto',
      current_position: 'Posición actual',
      disable: 'Deshabilitar',
      document_settings: 'Configuración del documento',
      door_protect: 'Protector de puerta',
      door_protect_desc: 'Disponible solo con Promark Safe+.',
      enable_autofocus: 'Enfoque automático',
      enable_diode: 'Diodo láser',
      enable_nozzle_refresh_area: 'Habilitar área de actualización de la boquilla',
      extend_y_area: 'Ampliar el área Y',
      frame_before_start: 'Enmarcar antes de ejecutar',
      frame_before_start_url: 'https://support.flux3dp.com/hc/en-us/articles/11494925637135',
      job_origin: 'Origen del trabajo',
      laser_source: 'Fuente del láser',
      machine: 'Máquina',
      manual: 'Manual',
      notification: {
        changeFromPrintingWorkareaTitle: '¿Desea convertir las capas de impresión en capas láser?',
      },
      origin: 'Origen',
      pass_through: 'Paso directo',
      pass_through_height_desc: 'Introduzca la longitud del objeto para ampliar el área de trabajo.',
      rotary_mode: 'Rotativo',
      scale: 'Escala',
      skip_prespray: 'Omitir purgado',
      start_from: 'Comenzar desde',
      start_position: 'Posición de inicio',
      start_work_button: 'Botón ejecutar',
      workarea: 'Área de trabajo',
    },
    elements_panel: {
      animals: 'Animal',
      arrow: 'Flecha',
      avatar: 'Avatar',
      basic: 'Básico',
      birds: 'Pájaro',
      browse_categories: 'Explorar categorías',
      celebration: 'Celebración',
      circular: 'Circular',
      cleaning_tools: 'Herramientas de limpieza',
      CNY: 'Año Nuevo lunar',
      corner: 'Esquina',
      decor: 'Decoración',
      doctor: 'Doctor',
      easter: 'Semana Santa',
      elements: 'Elementos',
      environment: 'Medio ambiente',
      gardening_tools: 'Herramientas de jardinerí',
      graphics: 'Gráficas',
      halloween: 'Halloween',
      hammer_wrench: 'Martillo y llave inglesa',
      heart: 'Corazón',
      holidays: 'Vacaciones',
      insect: 'Insecto',
      kitchen_tools: 'Utensilios de cocina',
      label: 'Etiqueta',
      land: 'Tierra',
      line: 'Línea',
      load_more: 'Cargar los siguientes 100 resultados',
      nature: 'Naturaleza',
      people: 'Personas',
      photo: 'Foto',
      plants: 'Planta',
      police: 'Política',
      recently_used: 'Usado recientemente',
      ribbon: 'Cinta',
      sea: 'Mar',
      search_examples: 'Ejemplos:',
      search_invalid_characters: 'Se han utilizado caracteres no válidos.',
      search_no_results: 'No se encontraron resultados para "%s". Por favor, revise la ortografía o pruebe con otra palabra clave.',
      search_with_english: 'Solo se permiten letras en inglés, números, comas y espacios.',
      shape: 'Forma',
      sign_in: 'Inicia sesión para obtener más de 10.000 iconos gratis',
      speech: 'Discurso',
      student: 'Estudiante',
      study_tools: 'Herramientas de estudio',
      teacher: 'Profesor',
      text: 'Marco de texto',
      title: 'Elementos',
      tools: 'Herramientas',
      valentines: 'San Valentín',
      weather: 'Clima',
      Xmas: 'Navidad',
    },
    image_trace_panel: {
      back: 'Volver',
      brightness: 'Brillo',
      cancel: 'Cancelar',
      contrast: 'Contraste',
      next: 'Siguiente',
      okay: 'De acuerdo',
      threshold: 'Umbral',
      tuning: 'Parámetros',
    },
    layer_color_config_panel: {
      add: 'Añadir',
      add_config: 'Añadir color',
      color: 'Color',
      default: 'Restablecer valores predeterminados',
      in_use: 'Se está usando este color.',
      layer_color_config: 'Configuraciones del color de las capas',
      no_input: 'Por favor, introduzca un código válido de color hexadecimal.',
      power: 'Potencia',
      repeat: 'Ejecutar',
      speed: 'Velocidad',
      sure_to_delete: '¿Está seguro que desea eliminar esta configuración de color?',
      sure_to_reset: 'Perderá todos los parámetros personalizados, ¿está seguro que desea restablecer los valores predeterminados?',
    },
    left_panel: {
      borderless_blind_area: 'Área no grabada',
      borderless_preview: 'Vista previa de la cámara en modo fondo sin bordes',
      diode_blind_area: 'Área ciega híbrida con láser adicional',
      label: {
        adjust_height: 'Ajustar altura',
        array: 'Matriz',
        boxgen: 'Boxgen',
        choose_camera: 'Cámara',
        clear_preview: 'Borrar vista previa',
        cursor: 'Seleccionar',
        curve_engraving: {
          clear_area: 'Borrar área seleccionada',
          exit: 'Salir',
          preview_3d_curve: 'Vista previa del grabado de curvas',
          select_area: 'Seleccionar área',
          title: 'Grabado de curvas',
        },
        elements: 'Elementos',
        end_preview: 'Finalizar vista previa',
        line: 'Línea',
        live_feed: 'Transmisión en directo',
        my_cloud: 'Mi nube',
        oval: 'Óvalo',
        pass_through: 'Paso directo',
        pen: 'Lápiz',
        photo: 'Imagen',
        polygon: 'Polígono',
        preview: 'Vista previa de la cámara',
        preview_wide_angle: 'Vista previa de la cámara de gran angular',
        qr_code: 'Código QR',
        rect: 'Rectángulo',
        text: 'Texto',
        trace: 'Rastrear imagen',
      },
      unpreviewable_area: 'Área ciega',
    },
    network_testing_panel: {
      average_response: 'Tiempo medio de respuesta',
      cannot_connect_1: '#840 Error en la conexión con la IP de destino.',
      cannot_connect_2: '#840 Error en la conexión con la IP de destino. Asegúrese de que el destinatario se encuentra en la misma red.',
      cannot_get_local: 'Error al acceder a la dirección IP local.',
      connection_quality: 'Calidad de la conexión',
      device_not_on_list: '#842 La máquina no está en la lista, pero la calidad de la conexión es >70 y el tiempo medio de respuesta es <100 ms.',
      empty_ip: '#818 Por favor, introduzca primero la IP del dispositivo de destino.',
      end: 'Fin',
      fail_to_start_network_test: '#817 Error al iniciar las pruebas de red.',
      hint_connect_camera_timeout: '¿Se produce un tiempo de espera al iniciar la vista previa de la cámara?',
      hint_connect_failed_when_sending_job: '¿No se ha podido conectar al enviar un trabajo?',
      hint_device_often_on_list: '¿La máquina no aparece a menudo en la lista?',
      insert_ip: 'Dirección IP del dispositivo de destino:',
      invalid_ip: '#818 Dirección IP no válida',
      ip_startswith_169: '#843 La dirección IP de la máquina comienza por 169.254',
      link_connect_camera_timeout: 'https://support.flux3dp.com/hc/en-us/articles/360001791895',
      link_connect_failed_when_sending_job: 'https://support.flux3dp.com/hc/en-us/articles/360001841656',
      link_device_often_on_list: 'https://tupport.flux3dp.com/hc/en-us/articles/360001841636',
      linux_permission_hint: 'Este error suele ocurrir debido a permisos insuficientes.\nPor favor ejecute "sudo beam-studio --no-sandbox" en el terminal para obtener permisos y realizar pruebas de red.',
      local_ip: 'Dirección IP local:',
      network_testing: 'Pruebas de red',
      network_unhealthy: '#841 Calidad de conexión <70 o tiempo medio de respuesta >100 ms',
      start: 'Iniciar',
      test_completed: 'Prueba completada',
      test_fail: 'Prueba fallida',
      testing: 'Probando red...',
    },
    object_panels: {
      lock_desc: 'Conservar la relación entre el ancho y el alto (SHIFT)',
      text_to_path: {
        check_thumbnail_warning: 'Algunos textos se cambiaron a otras fuentes al convertir textos en trayectorias y es posible que algunos caracteres no se hayan convertido correctamente.\nPor favor, compruebe de nuevo la imagen de vista previa antes de enviar la tarea.',
        error_when_parsing_text: 'Error al convertir texto en trayectoria',
        font_substitute_pop: 'Su texto contiene caracteres que no son compatibles con la fuente actual. <br/>¿Desea utilizar <strong>%s</strong> como sustitución?',
        retry: 'Por favor, vuelva a intentarlo más tarde o elija otra fuente.',
        use_current_font: 'Usar fuente actual',
      },
      wait_for_parsing_font: 'Analizando fuente... Por favor, espere un momento.',
    },
    path_preview: {
      current_position: 'Posición actual',
      cut_distance: 'Distancia de corte',
      cut_time: 'Tiempo de corte',
      end_preview: 'Fin de la vista previa',
      estimated_time: 'Tiempo total estimado',
      invert: 'Invertir',
      pause: 'Pausa',
      play: 'Reproducir',
      play_speed: 'Velocidad de reproducción',
      preview_info: 'Información de vista previa',
      rapid_distance: 'Distancia recorrida',
      rapid_time: 'Tiempo del movimiento',
      remark: '* Toda la información es un valor estimado a modo de referencia.',
      size: 'Tamaño',
      start_here: 'Comenzar aquí',
      stop: 'Detener',
      travel_path: 'Trayectoria del movimiento',
    },
    photo_edit_panel: {
      aspect_ratio: 'Relación de aspecto',
      brightness: 'Brillo',
      brightness_and_contrast: 'Brillo / Contraste',
      circumference: 'Circunferencia',
      compare: 'Comparar',
      contrast: 'Contraste',
      crop: 'Recorte',
      curve: 'Curva',
      diameter: 'Diámetro',
      free: 'Libre',
      invert: 'Invertir el color',
      original: 'Original',
      phote_edit: 'Edición de fotos',
      processing: 'Procesando',
      radius: 'Radio',
      rotary_warped: 'Rotativo deformado',
      rotary_warped_link: 'https://support.flux3dp.com/hc/en-us/articles/10828006201103',
      sharpen: 'Afilar',
      sharpness: 'Nitidez',
      start: 'Comenzar',
      warp: 'Deformar',
    },
    popup: {
      ai_credit: {
        buy_link: 'https://member.flux3dp.com/en-US/credit',
        insufficient_credit: 'Se quedo sin créditos',
        insufficient_credit_msg: 'No puede usar el %s. Vaya al centro de miembros y compre crédito AI.',
        relogin_to_use: 'Por favor, vuelva a iniciar sesión para usar esta función.',
      },
      auto_feeder_origin: 'Utilice la vista previa de encuadre para comprobar la trayectoria y el área del cabezal láser y, a continuación ajuste la colocación del material o la posición de inicio del grabado en función de los resultados, para evitar colisiones durante el proceso de grabado.',
      auto_switch_tab: {
        message: 'Se ha añadido una nueva opción a Preferencias para cambiar automáticamente entre el panel Capas y el panel Objetos. Esta opción está desactivada por defecto. ¿Desea activar el cambio automático ahora?<br/>Puede cambiar esta configuración en cualquier momento en Preferencias.',
        title: 'Cambio automático de panel de capa y objeto',
      },
      backend_connect_failed_ask_to_upload: '#802 Se siguen produciendo errores al intentar conectarse a la parte trasera. ¿Desea cargar su registro de informe de errores?',
      backend_error_hint: 'Es posible que las funciones no funcionen correctamente debido a un error en la parte trasera.',
      both_power_and_speed_too_high: 'El uso de una potencia de láser más baja prolongará la vida útil del tubo láser.\nAdemás, una velocidad demasiado alta con esta resolución puede dar lugar a una menor calidad del grabado.',
      bug_report: 'Informe de errores',
      change_workarea_before_preview: 'El área de trabajo de %s no coincide con el actual área de trabajo configurado. ¿Desea cambiar el área de trabajo actual?',
      convert_to_path_fail: 'No se ha podido convertir a trayectoria',
      disassemble_use: {
        clip_path_warning: 'Este archivo contiene una máscara de recorte y no se puede desmontar.',
        execute_time_warning: 'Se desagruparán los archivos DXF o SVG importados. Dado que el archivo puede contener un gran número de elementos, es posible que el desagrupado tarde algún tiempo.\n¿Está seguro que desea continuar?',
      },
      dxf_bounding_box_size_over: 'El tamaño del dibujo está fuera del área de trabajo. Acerque el dibujo al origen en su programa CAD o asegúrese de que la unidad esté configurada correctamente.',
      dxf_version_waring: 'La versión de este archivo DXF no es 2013, por lo que podrían surgir problemas de incompatibilidad.',
      facebook_group_invitation: {
        already_joined: 'Ya está unido',
        join_now: 'Cuente conmigo',
        later: 'Quizá más tarde',
        message: 'Únase a nuestro grupo oficial de Facebook para conectar con otros usuarios de FLUX laser, hablar sobre los láseres FLUX, compartir diseños y estar al día de las últimas novedades sobre nuestros productos. ¡Estamos deseando verle allí!',
        title: 'Únase al grupo oficial de usuarios de FLUX',
      },
      failed_to_load_svg: 'No se pueden cargar los datos SVG',
      import_file_contain_invalid_path: '#808 El archivo SVG importado contiene una ruta de imagen no válida. Asegúrese de que todos los archivos de imagen existen o integre la imagen en el archivo.',
      import_file_error_ask_for_upload: 'No se ha podido importar el archivo SVG. ¿Desea proporcionar el archivo al equipo de desarrollo para que pueda elaborar un informe de errores?',
      import_svg: {
        advice_message: 'Esto puede provocar un retraso considerable o un error de importación.',
        advice_message_2: 'Se recomienda simplificar el archivo antes de importarlo.',
        confirmation_message: '¿Desea continuar?',
        element_count_warning: 'Número de elementos: %s (Recomendado: < %s).',
        file_size_warning: 'Tamaño del archivo: %s MB (Recomendado: < %s MB).',
        intro_message: 'El archivo puede ser demasiado grande o complejo:',
        path_d_command_count_warning: 'Número de comandos: %s (Recomendado: < %s).',
        title: 'Advertencia sobre la importación de archivos',
      },
      layer_by_color: 'Color',
      layer_by_layer: 'Capa',
      loading_image: 'Cargando imagen, por favor espere...',
      more_than_two_object: 'Demasiados objetos. Solo se admiten 2 objetos.',
      mouse: 'Ratón',
      no_curve_engraving_with_modules: 'Este trabajo incluye grabado de superficies curvas, lo que no puede utilizarse junto con la impresión en color. Desactive la capa de impresión en color y vuelva a enviar el trabajo.',
      no_support_text: 'Beam Studio actualmente no admite etiquetas de texto. Transfiera el texto a trayectoria antes de importarlo.',
      nolayer: 'Una sola capa',
      not_support_object_type: 'No es compatible con el tipo de objeto',
      or_turn_off_borderless_mode: 'O desactive el modo de fondo sin bordes',
      path_engine_upgrade: {
        caption: 'Generación de trabajos más rápida disponible',
        keep_current: 'Mantener actual',
        message: 'Hemos actualizado el motor de cálculo de trabajos para mejorar el rendimiento y acelerar la generación de trabajos.\n¿Desea cambiar al nuevo motor acelerado?\nPuede desactivarlo en cualquier momento en %(preferences)s > %(editor)s > %(path_acceleration)s.',
      },
      pdf2svg: {
        error_pdf2svg_not_found: '#825 Error: No se encuentra el comando pdf2svg. Por favor, instale pdf2svg con su gestor de programas (p.e., "yum install pdf2svg" o "apt-get install pdf2svg").',
        error_when_converting_pdf: '#824 Error al convertir PDF a SVG:',
      },
      progress: {
        calculating: 'Calculando',
        uploading: 'Cargando',
      },
      questionnaire: {
        caption: 'Ayúdenos a completar el cuestionario',
        message: 'Ayúdanos a completar el cuestionario para mejorar Beam Studio.',
        no_questionnaire_available: 'En este momento no hay ningún cuestionario disponible.',
        unable_to_get_url: 'No se ha podido obtener el enlace al cuestionario a través de Internet. Por favor, compruebe su conexión.',
      },
      reach_tab_count_limit: 'Se ha alcanzado el límite de pestañas.',
      recommend_downgrade_software: 'Se ha detectado una versión anterior del firmware. Estamos trabajando activamente para resolver los problemas de compatibilidad, pero por ahora recomendamos volver a <a target="_blank" href="https://beamstudio.s3.ap-northeast-1.amazonaws.com/mac/Beam+Studio+1.9.5.dmg">Beam Studio 1.9.5</a>.',
      recommend_upgrade_firmware: 'Se ha detectado una versión anterior de firmware. Estamos trabajando activamente para resolver los problemas de compatibilidad, pero por ahora recomendamos actualizar al firmware más reciente.',
      save_unsave_changed: '¿Desea guardar los cambios no guardados?',
      select_at_least_two: 'Seleccione dos objetos para continuar',
      select_first: 'Seleccione un objeto primero.',
      select_import_method: 'Selecciona el estilo de las capas:',
      select_import_module: 'Seleccione el módulo:',
      sentry: {
        message: '¿Acepta enviar automáticamente la información relevante al equipo de desarrollo, cuando se produzcan errores?',
        title: 'Mejoremos juntos Beam Studio.',
      },
      should_update_firmware_to_continue: '#814 Su firmware no es compatible con esta versión de Beam Studio. Actualice el firmware para continuar. (Menú > Máquina > [Su máquina] > Actualizar firmware)',
      speed_too_high_lower_the_quality: 'El uso de una velocidad demasiado alta con esta resolución puede dar lugar a una menor calidad del grabado.',
      still_continue: 'Continuar',
      successfully_uploaded: 'La carga del archivo se ha realizado correctamente.',
      svg_1_1_waring: 'La versión de este archivo SVG es la v 1.1, por lo que podrían darse problemas de incompatibilidad.',
      svg_image_path_waring: 'Este archivo SVG contiene <imagen> que se carga desde la ruta del archivo. Esto puede provocar errores durante la carga.\nPara evitar este riesgo, utilice imágenes incrustadas al exportar SVG.',
      text_to_path: {
        caption: 'Conversor de texto a trayectoria 2.0',
        message: 'Beam Studio presenta ahora un nuevo conversor de texto a trayectoria (Converter 2.0), que ofrece resultados más fiables. ¿Desea cambiar a él ahora?\nTambién puede ajustar mas tarde esta configuración en la sección "Conversor de texto a trazado" de Preferencias.',
      },
      too_fast_for_auto_feeder: 'El uso de una velocidad demasiado alta en capas que contienen objetos de trazado puede reducir la precisión del corte.\nNo recomendamos el uso de una velocidad superior a %(limit)s al cortar con el alimentador automático.',
      too_fast_for_auto_feeder_and_constrain: 'Las siguientes capas: %(layers)s contienen objetos de trazado vectorial y tienen una velocidad superior a %(limit)s.\nLa velocidad de corte de los objetos de trazado vectorial con el alimentador automático se limitará a %(limit)s.\nPuede eliminar este límite en Configuración de Preferencias.',
      too_fast_for_curve: 'En el modo de grabado curvo, la velocidad actual puede ser demasiado alta y podría afectar los detalles del grabado en las capas: %(layers)s.\nConsidere reducir la velocidad para obtener mejor calidad.',
      too_fast_for_path: 'El uso de una velocidad demasiado alta en capas que contienen objetos de trazado puede resultar en una menor precisión de corte.\nNo recomendamos el uso de una velocidad superior a %(limit)s al cortar.',
      too_fast_for_path_and_constrain: 'Las siguientes capas: %(layers)s contienen objetos de trazado vectorial y tienen una velocidad superior a %(limit)s.\nLa velocidad de corte de los objetos de trazado vectorial se limitará a %(limit)s.\nPuede eliminar este límite en Configuración de Preferencias.',
      touchpad: 'Panel táctil',
      upload_failed: '#819 No se ha podido cargar el archivo.',
      upload_file_too_large: '#819 El archivo es demasiado grande para cargarlo.',
      vectorize_shading_image: 'Las imágenes con degradado tardan más tiempo en trazarse y son propensas al ruido. Por favor, desactive el degradado de la imagen antes de ejecutar.',
    },
    rating_panel: {
      description: 'Si le gusta Beam Studio, le agradeceríamos que compartiera su experiencia.',
      thank_you: 'Gracias',
      title: '¿Le gusta Beam Studio?',
    },
    right_panel: {
      laser_panel: {
        advanced: 'Avanzado',
        air_assist: 'Asistencia neumática',
        am_density: 'Densidad AM',
        backlash: 'Holgura',
        bi_directional: 'Bidireccional',
        by: 'Por',
        ce_z_high_speed: 'Eje Z de alta velocidad',
        ce_z_high_speed_link: 'https://support.flux3dp.com/hc/en-us/articles/10364060644495',
        color_adjustment: 'Ajuste de canal',
        color_adjustment_short: 'Canal',
        color_strength: 'Intensidad',
        cross_hatch: 'Sombreado cruzado',
        custom_preset: 'Personalizado',
        cut: 'Cortar',
        diode: 'Diodo láser',
        do_not_adjust_default_para: 'Los ajustes preestablecidos no se pueden modificar.',
        dottingTime: 'Tiempo de punteado',
        dropdown: {
          inches: {
            abs_engraving: 'ABS - Grabado',
            acrylic_3mm_cutting: 'Metacrilato 1/8″ - Corte',
            acrylic_5mm_cutting: 'Metacrilato 3/16″ - Corte',
            acrylic_7mm_cutting: 'Metacrilato 1/4″ - Corte',
            acrylic_8mm_cutting: 'Metacrilato 1/4″ - Corte',
            acrylic_10mm_cutting: 'Metacrilato 3/8″ - Corte',
            acrylic_engraving: 'Metacrilato - Grabado',
            acrylic_printing: 'Metacrilato - Impresión',
            aluminum_engraving: 'Aluminio - Grabado',
            aluminum_light: 'Aluminio (claro)',
            bamboo_2mm_cutting: 'Bambú 5/64″ - Corte',
            bamboo_5mm_cutting: 'Bambú 3/16″ - Corte',
            bamboo_printing: 'Bambú - Impresión',
            black_abs: 'ABS negro',
            black_acrylic_3mm_cutting: 'Metacrilato negro 1/8″ - Corte',
            black_acrylic_5mm_cutting: 'Metacrilato negro 3/16″ - Corte',
            black_acrylic_engraving: 'Metacrilato negro - Grabado',
            brass_dark: 'Latón (oscuro)',
            brass_engraving: 'Latón - Grabado',
            brass_light: 'Latón (claro)',
            canvas_fabric_printing: 'Lona - Impresión',
            canvas_printing: 'Tela - Impresión',
            cardboard_printing: 'Cartón - Impresión',
            cardstock_printing: 'Cartulina - Impresión',
            copper: 'Cobre',
            cork_printing: 'Corcho - Impresión',
            denim_1mm_cutting: 'Tela vaquera 1/32″ - Corte',
            fabric_3mm_cutting: 'Tejido 1/8″ - Corte',
            fabric_5mm_cutting: 'Tejido 3/16″ - Corte',
            fabric_engraving: 'Tejido - Grabado',
            fabric_printing: 'Tejido - Impresión',
            flat_stone_printing: 'Piedra plana - Impresión',
            glass_bw_engraving: 'Vidrio - Grabado',
            glass_printing: 'Vidrio - Impresión',
            gloss_leather_printing: 'Cuero brillante - Impresión',
            gold_engraving: 'Oro - Grabado',
            iron_engraving: 'Hierro - Grabado',
            leather_3mm_cutting: 'Cuero 1/8″ - Corte',
            leather_5mm_cutting: 'Cuero 3/16″ - Corte',
            leather_engraving: 'Cuero - Grabado',
            leather_printing: 'Cuero - Impresión',
            mdf_3mm_cutting: 'MDF (DM) 1/8″ - Corte',
            mdf_5mm_cutting: 'MDF (DM) 3/16″ - Corte',
            mdf_7mm_cutting: 'MDF (DM) 1/4″ - Corte',
            mdf_engraving: 'MDF (DM) - Grabado',
            mdf_printing: 'MDF (DM) - Impresión',
            metal_bw_engraving: 'Metal - Grabado',
            opaque_acrylic: 'Metacrilato opaco',
            pc_printing: 'PC - Impresión',
            rubber_bw_engraving: 'Goma - Grabado',
            silver_engraving: 'Plata - Grabado',
            slate_engraving: 'Pizarra - Grabado',
            stainless_steel_bw_engraving_diode: 'Metal - Grabado (Diodo láser)',
            stainless_steel_dark: 'Acero inoxidable (oscuro)',
            stainless_steel_engraving: 'Acero inoxidable - Grabado',
            stainless_steel_light: 'Acero inoxidable (claro)',
            stainless_steel_printing: 'Acero inoxidable - Impresión',
            steel_engraving_spray_engraving: 'Metal - Grabado',
            sticker_kiss_cut: 'Pegatina - Corte',
            sticker_printing: 'Pegatina - Impresión',
            stone: 'Piedra',
            ti_engraving: 'Titanio - Grabado',
            titanium_dark: 'Titanio (oscuro)',
            titanium_light: 'Titanio (claro)',
            white_abs: 'ABS blanco',
            wood_3mm_cutting: 'Madera 1/8″ - Corte',
            wood_5mm_cutting: 'Madera 3/16″ - Corte',
            wood_7mm_cutting: 'Madera 1/4″ - Corte',
            wood_8mm_cutting: 'Madera 1/4″ - Corte',
            wood_10mm_cutting: 'Madera 3/8″ - Corte',
            wood_engraving: 'Madera - Grabado',
            wood_printing: 'Madera - Impresión',
          },
          mm: {
            abs_engraving: 'ABS - Grabado',
            acrylic_3mm_cutting: 'Metacrilato 3 mm - Corte',
            acrylic_5mm_cutting: 'Metacrilato 5 mm - Corte',
            acrylic_7mm_cutting: 'Metacrilato 7 mm - Corte',
            acrylic_8mm_cutting: 'Metacrilato 8 mm - Corte',
            acrylic_10mm_cutting: 'Metacrilato 10 mm - Corte',
            acrylic_engraving: 'Metacrilato - Grabado',
            acrylic_printing: 'Metacrilato - Impresión',
            aluminum_engraving: 'Aluminio - Grabado',
            aluminum_light: 'Aluminio (claro)',
            bamboo_2mm_cutting: 'Bambú 2 mm - Corte',
            bamboo_5mm_cutting: 'Bambú 5 mm - Corte',
            bamboo_printing: 'Bambú - Impresión',
            black_abs: 'ABS negro',
            black_acrylic_3mm_cutting: 'Metacrilato negro 3 mm - Corte',
            black_acrylic_5mm_cutting: 'Metacrilato negro 5 mm - Corte',
            black_acrylic_engraving: 'Metacrilato negro - Grabado',
            brass_dark: 'Latón (oscuro)',
            brass_engraving: 'Latón - Grabado',
            brass_light: 'Latón (claro)',
            canvas_fabric_printing: 'Lona - Impresión',
            canvas_printing: 'Tela - Impresión',
            cardboard_printing: 'Cartón - Impresión',
            cardstock_printing: 'Cartulina - Impresión',
            copper: 'Cobre',
            cork_printing: 'Corcho - Impresión',
            denim_1mm_cutting: 'Tela vaquera 1 mm - Corte',
            fabric_3mm_cutting: 'Tejido 3 mm - Corte',
            fabric_5mm_cutting: 'Tejido 5 mm - Corte',
            fabric_engraving: 'Tejido - Grabado',
            fabric_printing: 'Tejido - Impresión',
            flat_stone_printing: 'Piedra plana - Impresión',
            glass_bw_engraving: 'Vidrio - Grabado',
            glass_printing: 'Vidrio - Impresión',
            gloss_leather_printing: 'Cuero brillante - Impresión',
            gold_engraving: 'Oro - Grabado',
            iron_engraving: 'Hierro - Grabado',
            leather_3mm_cutting: 'Cuero 3 mm - Corte',
            leather_5mm_cutting: 'Cuero 5 mm - Corte',
            leather_engraving: 'Cuero - Grabado',
            leather_printing: 'Cuero - Impresión',
            mdf_3mm_cutting: 'MDF (DM) 3 mm - Corte',
            mdf_5mm_cutting: 'MDF (DM) 5 mm - Corte',
            mdf_7mm_cutting: 'MDF (DM) 7 mm - Corte',
            mdf_engraving: 'MDF (DM) - Grabado',
            mdf_printing: 'MDF (DM) - Impresión',
            metal_bw_engraving: 'Metal - Grabado',
            opaque_acrylic: 'Metacrilato opaco',
            pc_printing: 'PC - Impresión',
            rubber_bw_engraving: 'Goma - Grabado',
            silver_engraving: 'Plata - Grabado',
            slate_engraving: 'Pizarra - Grabado',
            stainless_steel_bw_engraving_diode: 'Metal - Grabado (Diodo láser)',
            stainless_steel_dark: 'Acero inoxidable (oscuro)',
            stainless_steel_engraving: 'Acero inoxidable - Grabado',
            stainless_steel_light: 'Acero inoxidable (claro)',
            stainless_steel_printing: 'Acero inoxidable - Impresión',
            steel_engraving_spray_engraving: 'Metal - Grabado',
            sticker_kiss_cut: 'Pegatina - Corte',
            sticker_printing: 'Pegatina - Impresión',
            stone: 'Piedra',
            ti_engraving: 'Titanio - Grabado',
            titanium_dark: 'Titanio (oscuro)',
            titanium_light: 'Titanio (claro)',
            white_abs: 'ABS blanco',
            wood_3mm_cutting: 'Madera 3 mm - Corte',
            wood_5mm_cutting: 'Madera 5 mm - Corte',
            wood_7mm_cutting: 'Madera 7 mm - Corte',
            wood_8mm_cutting: 'Madera 8 mm - Corte',
            wood_10mm_cutting: 'Madera 10 mm - Corte',
            wood_engraving: 'Madera - Grabado',
            wood_printing: 'Madera - Impresión',
          },
          parameters: 'Preajustes',
          save: 'Añadir parámetros actuales',
        },
        engrave: 'Grabar',
        existing_name: 'Se ha utilizado este nombre.',
        fill_angle: 'Ángulo de relleno',
        fill_interval: 'Intervalo de relleno',
        fill_setting: 'Configuración del relleno',
        filled_path_only: 'Solo para trayectorias de relleno',
        focus_adjustment: 'Ajuste del enfoque',
        frequency: 'Frecuencia',
        gradient_only: 'Solo para imágenes degradadas',
        halftone: 'Semitono',
        halftone_link: 'https://support.flux3dp.com/hc/en-us/articles/9402670389647',
        height: 'Altura del objeto',
        ink_saturation: 'Saturación',
        low_air_assist_warning: 'Se recomienda ajustar la asistencia de aire por encima del 50 % para reducir eficazmente el riesgo de que el material se incendie.',
        low_power_warning: 'Una potencia láser inferior (por debajo del 10 %) podría no emitir la luz láser.',
        low_speed_warning: 'Una velocidad baja puede provocar que el material se queme.',
        lower_focus: 'Reducir enfoque',
        lower_focus_desc: 'Reducir la altura de enfoque a una distancia específica para mejorar el rendimiento de corte.',
        module: 'Módulo',
        more: 'Gestionar',
        multi_layer: 'Capas múltiples',
        para_in_use: 'Este parámetro se está utilizado.',
        parameters: 'Parámetros',
        preset_management: {
          add_new: 'Añadir nuevo',
          delete: 'Eliminar',
          export: 'Exportar',
          export_preset_title: 'Exportar preajustes',
          import: 'Importar',
          laser: 'Láser',
          lower_focus_by: 'Reducir el enfoque mediante',
          new_preset_name: 'Nuevo nombre predefinido',
          preset: 'Preajuste',
          print: 'Imprimir',
          reset: 'Restablecer',
          save_and_exit: 'Guardar y salir',
          show_all: 'Mostrar todo',
          sure_to_import_presets: 'Se cargará la configuración de los ajustes preestablecidos y se anularán los parámetros personalizados. ¿Está seguro que desea continuar?',
          sure_to_reset: 'Se eliminarán sus parámetros personalizados y se restablecerán todos los ajustes preestablecidos.\n¿Está seguro que desea continuar?',
          title: 'Administrar parámetros',
          wobble_diameter: 'Diámetro de oscilación',
          wobble_step: 'Tamaño del paso de oscilación',
        },
        preset_setting: 'Configuración de parámetros (%s)',
        presets: 'Preajuste',
        print_multipass: 'Paso múltiple',
        promark_speed_desc: 'Los parámetros de velocidad no son aplicables a las imágenes de gradiente.',
        pulse_width: 'Ancho de pulso',
        pwm_advanced_desc: 'Establecer una potencia mínima para el modo Profundidad.',
        pwm_advanced_hint: 'Esta configuración se aplica específicamente a las imágenes con degradado cuando se utiliza el modo Profundidad.',
        pwm_advanced_setting: 'Configuración de potencia del modo de Profundidad',
        refresh_interval: 'Intervalo de actualización',
        refresh_printer: 'Actualización del cabezal de impresión',
        repeat: 'Número de pasadas',
        single_color: 'Color único',
        single_color_desc: 'Solo aplicable a capas a todo color y no puede utilizarse con capas expandidas de un solo color.',
        slider: {
          fast: 'Rápido',
          high: 'Alto',
          low: 'Bajo',
          regular: 'Regular',
          slow: 'Lento',
          very_fast: 'Más rápido',
          very_high: 'Máx',
          very_low: 'Mín',
          very_slow: 'Más lento',
        },
        speed: 'Velocidad',
        speed_constrain_warning: 'La velocidad de corte de los objetos de trazado vectorial se limitará a %(limit)s. Puede eliminar este límite en Configuración de Preferencias.',
        speed_constrain_warning_auto_feeder: 'La velocidad de corte de los objetos del alimentador automático se limitará a %(limit)s. Puede eliminar este límite en Configuración de Preferencias.',
        speed_constrain_warning_curve_engraving: 'La velocidad de grabado de objetos curvos se limitará a %(limit)s. Puede eliminar este límite en Configuración de Preferencias.',
        speed_constrain_warning_module_addon: 'Al utilizar un módulo adicional, evite velocidades superiores a %(limit)s para mantener la calidad del grabado.',
        stepwise_focusing: 'Enfoque gradual',
        stepwise_focusing_desc: 'Reducción gradual de la distancia de enfoque en función de la altura del objeto en cada recuento de pasadas.',
        strength: 'Potencia',
        times: 'veces',
        various_preset: 'Varios preajustes',
        white_ink: 'Tinta blanca',
        white_ink_settings: 'Configuración de la tinta blanca',
        wobble: 'Oscilación',
        wobble_desc: 'Cree pequeños círculos a lo largo de la trayectoria, lo que es útil para las tareas de corte (solo para objetos de trazado).',
        wobble_diameter: 'Diámetro',
        wobble_step: 'Tamaño del paso',
        z_step: 'Paso Z',
      },
      layer_panel: {
        current_layer: 'Capa actual',
        layer1: 'Capa 1',
        layer_bitmap: 'Mapa de bits',
        layer_cutting: 'Corte',
        layer_engraving: 'Grabado',
        layers: {
          del: 'Eliminar la capa',
          dupe: 'Duplicar la capa',
          fullColor: 'A todo color',
          layer: 'Capa',
          layers: 'Capas',
          lock: 'Bloquear capa',
          merge_all: 'Fusionar todo',
          merge_down: 'Fusionarse',
          merge_selected: 'Fusionar capas seleccionadas',
          move_down: 'Mover capa hacia abajo',
          move_elems_to: 'Mover los elementos a:',
          move_selected: 'Mover los elementos seleccionados a una capa diferente',
          move_up: 'Mover capa hacia arriba',
          new: 'Nueva capa',
          rename: 'Renombrar capa',
          splitFullColor: 'Expandir capa',
          switchToFullColor: 'Cambiar a capa a todo color',
          switchToSingleColor: 'Cambiar a capa de un solo color',
          unlock: 'Desbloquear',
        },
        move_elems_to: 'Mover los elementos a:',
        notification: {
          dupeLayerName: '¡Ya existe una capa con ese nombre!',
          enterNewLayerName: 'Por favor, introduzca el nombre de la nueva capa.',
          enterUniqueLayerName: 'Por favor, introduzca un nombre de capa única.',
          layerHasThatName: 'La capa ya tiene ese nombre',
          mergeLaserLayerToPrintingLayerMsg: 'Si completa esta operación, la configuración de la capa láser se eliminará y se establecerá según la capa actual.',
          mergeLaserLayerToPrintingLayerTitle: '¿Desea fusionar estas capas en una sola capa de impresión?',
          mergePrintingLayerToLaserLayerMsg: 'Si completa esta operación, la configuración de color de la capa de impresión se eliminará y se establecerá según la capa actual.',
          mergePrintingLayerToLaserLayerTitle: '¿Desea fusionar estas capas en una sola capa láser?',
          moveElemFromPrintingLayerMsg: 'Si completa esta operación, la configuración de color del elemento seleccionado se eliminará y se establecerá según %s.',
          moveElemFromPrintingLayerTitle: '¿Mover el elemento seleccionado a %s y convertirlo en elemento láser?',
          moveElemToPrintingLayerMsg: 'Tenga en cuenta que si completa esta operación, la configuración del elemento seleccionado se eliminará y se establecerá según %s.',
          moveElemToPrintingLayerTitle: '¿Mover el elemento seleccionado a %s y convertirlo en un elemento de impresión?',
          newName: 'NUEVO NOMBRE',
          QmoveElemsToLayer: "¿Mover los elementos seleccionados a la capa '%s'?",
          splitColorMsg: 'Si continúa con esta operación, no podrá volver a las capas de color originales.',
          splitColorTitle: '¿Desea expandir la capa seleccionada en capas CMYK?',
        },
      },
      object_panel: {
        actions_panel: {
          ai_bg_removal: 'Eliminación del fondo',
          ai_bg_removal_reminder: 'Presionar el botón usará inmediatamente 0.02 Credit, ¿quieres continuar?',
          ai_bg_removal_short: 'Eliminar fondo',
          array: 'Matriz',
          auto_fit: 'Ajuste automático',
          bevel: 'Bisel',
          brightness: 'Brillo',
          convert_to_image: 'Convertir en imagen',
          convert_to_path: 'Convertir en trayectoria',
          create_textpath: 'Crear texto en trayectoria',
          create_textpath_short: 'Texto de trayectoria',
          crop: 'Recorte',
          decompose_path: 'Descomponer',
          detach_path: 'Descomponer texto en trayectoria',
          detach_path_short: 'Descomponer',
          disabled_by_gradient: 'Desactive el degradado antes de utilizar esta función.',
          disabled_by_infilled: 'Cierre el relleno antes de utilizar esta función.',
          disabled_by_infilled_and_variable_text: 'Cierre el relleno y el texto variable antes de utilizar esta función.',
          disabled_by_variable_text: 'Cierre el texto variable antes de utilizar esta función.',
          disassemble_use: 'Desmontar',
          disassembling: 'Desmontando...',
          edit_path: 'Editar trayectoria',
          fetching_web_font: 'Obteniendo la fuente en línea...',
          grading: 'Calificación',
          invert: 'Invertir',
          offset: 'Desviación',
          outline: 'Contorno',
          replace_with: 'Sustituir con…',
          replace_with_short: 'Sustituir',
          sharpen: 'Afilar',
          simplify: 'Simplificar',
          smart_nest: 'Anidamiento Inteligente',
          trace: 'Traza',
          ungrouping: 'Desagrupando...',
          uploading_font_to_machine: 'Cargando fuente en la máquina...',
          wait_for_parsing_font: 'Analizando fuente... Por favor, espere un momento.',
          weld_text: 'Soldar texto',
        },
        align: 'Alinear',
        boolean: 'Booleano',
        bottom_align: 'Alineación inferior',
        center_align: 'Alinear al centro',
        difference: 'Diferencia',
        distribute: 'Distribuir',
        flip: 'Voltear',
        group: 'Agrupar',
        hdist: 'Distribución horizontal',
        hflip: 'Volteo horizontal',
        intersect: 'Intersección',
        left_align: 'Alinear a la izquierda',
        lock_aspect: 'Bloquear aspecto',
        middle_align: 'Alinear al medio',
        option_panel: {
          color: 'Color',
          current_time: 'Hora actual',
          depth_engraving: 'Grabado en relieve',
          fill: 'Relleno',
          font_family: 'Fuente',
          font_size: 'Tamaño',
          font_style: 'Estilo',
          layer_count: 'Número de capas',
          letter_spacing: 'Espaciado entre letras',
          line_spacing: 'Espaciado entre líneas',
          number: 'Número de secuencia',
          offset: 'Desviación',
          path_infill: 'Relleno del trazado',
          pwm_engraving: 'Modo profundidad',
          pwm_engraving_link: 'https://support.flux3dp.com/hc/en-us/articles/10419884701327',
          recently_used: 'Usado recientemente',
          rounded_corner: 'Esquina redondeada',
          shading: 'Gradiente',
          sides: 'Lados',
          start_offset: 'Desviación del texto',
          stroke: 'Borde',
          stroke_color: 'Color del borde',
          stroke_width: 'Ancho del borde',
          text_infill: 'Relleno del texto',
          threshold: 'Brillo umbral',
          threshold_short: 'Umbral',
          variable_text: 'Texto variable',
          variable_text_link: 'https://support.flux3dp.com/hc/en-us/articles/12689396604175',
          vertical_align: 'Alineación',
          vertical_text: 'Texto vertical',
        },
        path_edit_panel: {
          connect: 'Conectar',
          delete: 'Eliminar',
          disconnect: 'Desconectar',
          node_type: 'TIPO DE NODO',
          round: 'Circular',
          sharp: 'Afilado',
        },
        right_align: 'Alinear a la derecha',
        subtract: 'Restar',
        top_align: 'Alineación superior',
        ungroup: 'Desagrupar',
        union: 'Unión',
        unlock_aspect: 'Desbloquear aspecto',
        vdist: 'Distribución vertical',
        vflip: 'Volteo vertical',
        zoom: 'Ampliar',
      },
      tabs: {
        layers: 'Capas',
        objects: 'Objetos',
        path_edit: 'Editar trayectoria',
      },
      uv_print_block: {
        title: 'Impresión UV',
      },
    },
    svg_editor: {
      unable_to_fetch_clipboard_img: 'No se ha podido recuperar la imagen del portapapeles.',
      unnsupported_file_type: 'El tipo de archivo no es compatible directamente. Por favor, convierta el archivo a SVG o mapa de bits.',
    },
    tag: {
      g: 'Grupo',
      image: 'Imagen',
      text: 'Texto',
      use: 'Importar SVG',
    },
    time_est_button: {
      calculate: 'Estimar tiempo',
      estimate_time: 'Tiempo estimado:',
    },
    tool_panels: {
      _nest: {
        end: 'Cerrar',
        no_element: 'No hay ningún elemento que organizar.',
        rotations: 'Posible rotación',
        spacing: 'Espaciado',
        start_nest: 'Organizar',
        stop_nest: 'Detener',
      },
      _offset: {
        corner_type: 'Esquina',
        direction: 'Dirección de la desviación',
        dist: 'Distancia de la desviación',
        expand: 'Expandir',
        fail_message: 'No se han podido desviar los objetos.',
        inward: 'Hacia adentro',
        not_support_message: 'Los elementos seleccionados contienen etiquetas SVG no compatibles:\nImagen, Grupo, Texto y Objeto importado.',
        outward: 'Hacia afuera',
        round: 'Circular',
        sharp: 'Afilado',
        shrink: 'Contraer',
      },
      array_dimension: 'Dimensión de la matriz',
      array_interval: 'Intervalo de la matriz',
      cancel: 'Cancelar',
      columns: 'Cols.',
      confirm: 'Confirmar',
      dx: 'X',
      dy: 'Y',
      grid_array: 'Crear matriz de cuadrícula',
      nest: 'Optimización de la disposición',
      offset: 'Desviación',
      rows: 'Filas',
    },
    units: {
      mm: 'mm',
      walt: 'W',
    },
    zoom_block: {
      fit_to_window: 'Ajustar a la ventana',
    },
  },
  boxgen: {
    add_option: 'Añadir opción',
    basic_box: 'Caja básica',
    beam_radius: 'Compensación de corte',
    beam_radius_warning: 'Elimine la compensación de corte cuando los bordes o las juntas de la caja sean cortos para garantizar el montaje de la caja.',
    cancel: 'Cancelar',
    coming_soon: 'Próximamente',
    continue_import: 'Continuar con la importación',
    control_tooltip: 'Botón izquierdo para girar\nDesplazarse para ampliar\nBotón derecho para mover',
    control_tooltip_touch: 'Arrastrar para girar\nPellizcar para ampliar\nDos dedos para mover',
    cover: 'Portada',
    customize: 'Personalizar',
    depth: 'Profundidad',
    edge: 'Borde',
    finger: 'Dedo',
    finger_warning: 'La longitud interna del lado de la caja ha de ser de al menos 6 mm (0,24") para ser compatible con el ensamblaje de espigas.',
    height: 'Altura',
    import: 'Importar',
    inner: 'Interior',
    joints: 'Unión',
    max_dimension_tooltip: 'El ancho máximo es %s, el ajuste máximo de alto/fondo es %s.',
    merge: 'Fusionar',
    outer: 'Exterior',
    reset: 'Restablecer',
    tCount: 'Recuento de T',
    tCount_tooltip: 'El número de ranuras en T se aplica al lado corto; la cantidad del lado largo se calcula en función de su longitud.',
    tDiameter: 'Diámetro de T',
    text_label: 'Etiqueta',
    thickness: 'Espesor',
    title: 'BOXGEN',
    tLength: 'Longitud de T',
    tSlot: 'Ranura en T',
    tSlot_warning: 'La longitud del lado de la caja ha de ser de al menos 30 mm (1,18") para ser compatible con la unión mediante ranura en T.',
    volume: 'Volumen',
    width: 'Ancho',
    workarea: 'Área de trabajo',
    zoom: 'Ampliar',
  },
  buttons: {
    back: 'Volver',
    back_to_beam_studio: 'Volver a Beam Studio',
    done: 'Hecho',
    next: 'Siguiente',
  },
  calibration: {
    ador_autofocus_focusing_block: 'Pulse el icono "AF" de la página principal de la máquina durante 3 seg y deje que la sonda toque el bloque de enfoque.',
    ador_autofocus_material: 'Pulse el icono "AF" de la página principal de la máquina durante 3 seg y deje que la sonda toque suavemente el material.',
    align_4_0: 'Superior izquierda',
    align_4_1: 'Superior derecha',
    align_4_2: 'Inferior izquierda',
    align_4_3: 'Inferior derecha',
    align_8_0: 'Superior izquierda exterior',
    align_8_1: 'Superior derecha exterior',
    align_8_2: 'Inferior izquierda exterior',
    align_8_3: 'Inferior derecha exterior',
    align_8_4: 'Superior izquierda interior',
    align_8_5: 'Superior derecha interior',
    align_8_6: 'Inferior izquierda interior',
    align_8_7: 'Inferior derecha interior',
    align_bottom_left: 'Abajo izq.',
    align_bottom_right: 'Abajo der.',
    align_red_cross_cut: 'Por favor, alinee el centro de la cruz roja con la cruz de corte.',
    align_red_cross_print: 'Por favor, alinee el centro de la cruz roja con la cruz impresa.',
    align_top_left: 'Superior izquierda',
    align_top_right: 'Superior derecha',
    analyze_result_fail: 'No se ha podido analizar la imagen capturada. <br/>Asegúrese de lo siguiente: <br/>1. La imagen capturada está completamente cubierta con papel blanco. <br/>2. La plataforma está correctamente enfocada.',
    ask_for_skip_engraving_task: '¿Desea omitir el paso de grabado y luego tomar la foto y calibrar directamente?',
    ask_for_skip_printing_task: '¿Desea omitir el paso de impresión y luego tomar la foto y calibrar directamente?',
    at_focus_height: 'a la altura de enfoque',
    at_lower_height: 'a menor altura',
    back: 'Volver',
    beamo2_autofocus_material: 'Mueva manualmente el cabezal láser sobre el material y a continuación baje la sonda de enfoque para activar el enfoque automático.',
    calculating_camera_matrix: 'Calculando la matriz de la cámara...',
    calculating_regression_parameters: 'Calculando los parámetros de regresión...',
    calibrate_camera_before_calibrate_modules: 'Realice la calibración de la cámara antes de calibrar los módulos.',
    calibrate_done: 'Calibración realizada. Se obtiene una mayor precisión de la cámara cuando se enfoca con precisión.',
    calibrate_done_diode: 'Calibración realizada. Se ha guardado la desviación del módulo del diodo láser.',
    calibrate_success_msg: 'Calibrado correctamente.<br/>La puntuación de la calibración es %s (%.2f).',
    calibrating: 'Calibrando...',
    calibrating_with_device_pictures: 'Calibrando con imágenes del dispositivo...',
    camera_calibration: 'Calibración de la cámara',
    camera_parameter_saved_successfully: 'Parámetros de la cámara guardados con éxito.',
    cancel: 'Cancelar',
    charuco_auto_focus: 'Baje la sonda de enfoque para enfocar automáticamente en el papel del tablero de ajedrez.',
    charuco_capture: 'Pulse en "Siguiente" para capturar.',
    charuco_place_charuco_horizontal: 'Coloque el patrón de calibración horizontalmente en el <b>%s</b> del área de trabajo.',
    charuco_place_charuco_vertical: 'Coloque el patrón de calibración verticalmente en el <b>%s</b> del área de trabajo.',
    charuco_position_bottom_left: 'Inferior izquierda',
    charuco_position_bottom_right: 'Inferior derecha',
    charuco_position_center: 'Centro',
    charuco_position_left: 'Izquierda',
    charuco_position_right: 'Derecha',
    charuco_position_top_left: 'Superior izquierda',
    charuco_position_top_right: 'Superior derecha',
    check_checkpoint_data: 'Datos del punto de control',
    check_device_pictures: 'Comprobar imágenes del dispositivo',
    check_pnp_desc: 'Asegúrese de que los marcadores rojos estén alineados con los puntos de grabado; si no es así, pulse en "Atrás" para ajustarlos.',
    checking_checkpoint: 'Comprobando datos del punto de control...',
    checking_pictures: 'Comprobando imágenes del dispositivo...',
    click_next: 'Pulse en "Siguiente"',
    click_next_to_take_picture: 'Pulse en "Siguiente" para tomar una foto.',
    diode_calibration: 'Calibración del módulo de diodo láser',
    do_engraving: 'Hacer grabado',
    download_and_print_calibration_pattern: 'Descargue el archivo del patrón de calibración que aparece a continuación e imprímalo en A4 (o tamaño carta).',
    download_calibration_pattern: 'Descargar patrón de calibración',
    download_chessboard_file: 'Descargar archivo de tablero de ajedrez',
    downloading_checkpoint: 'Descargando datos del punto de control...',
    downloading_pictures: 'Descargando imágenes...',
    drawing_calibration_image: 'Dibujando la imagen de calibración...',
    dx: 'X',
    dy: 'Y',
    elevate_and_cut: 'Elevar y cortar',
    elevate_and_cut_step_1: 'Coloque una madera clara de tamaño A4 o carta en el centro del área de trabajo, elevada 20 mm.',
    elevate_and_cut_step_1_prism_lift: 'Utilice el elevador en prisma Ador, con una longitud máxima de 14 mm y una madera de al menos 6 mm de grosor.',
    failed_to_calibrate_camera: '#848 No se ha podido calibrar la cámara. Póngase en contacto con el servicio de asistencia de FLUX.',
    failed_to_calibrate_chessboard: 'No se ha podido calibrar con la imagen del tablero de ajedrez.',
    failed_to_calibrate_with_pictures: '#848 No se ha podido calibrar con las imágenes del dispositivo.',
    failed_to_detect_calibration_pattern: 'No se ha podido detectar el patrón de calibración. Ajuste la exposición de la cámara o cambie la posición del patrón de calibración e inténtelo de nuevo.',
    failed_to_download_pictures: '#848 No se han podido descargar las imágenes. Póngase en contacto con el servicio de asistencia de FLUX.',
    failed_to_move_laser_head: 'No se ha podido mover el cabezal del láser.',
    failed_to_parse_checkpoint: 'No se han podido analizar los datos del punto de control.',
    failed_to_save_calibration_results: '#849 No se han podido guardar los resultados de la calibración. Inténtelo de nuevo. Si el problema persiste, póngase en contacto con el servicio de asistencia de FLUX.',
    failed_to_save_camera_parameter: 'No se han podido guardar los parámetros de la cámara.',
    failed_to_solve_pnp: 'No se ha podido resolver la posición de la cámara.',
    finish: 'Hecho',
    found_checkpoint: 'Los datos del punto de control se encuentran en su dispositivo. ¿Desea recuperarlos desde el punto de control?',
    getting_plane_height: 'Obteniendo la altura del avión...',
    hint_adjust_parameters: 'Usa estos parámetros para ajustar el cuadro rojo',
    hint_red_square: 'Alinee el exterior del cuadro rojo con el cuadro recortado.',
    material_4_a4_paper: 'Cuatro hojas de papel blanco A4 (o tamaño carta).',
    material_a4_calibration_pattern: 'Patrón de calibración A4 (o tamaño carta).',
    materials_required: 'Materiales requeridos:',
    module_calibration_2w_ir: 'Calibración del módulo infrarrojo',
    module_calibration_printer: 'Calibración del módulo de impresión',
    module_offset_settings: 'Configuración de la desviación',
    module_offset_settings_desc: 'Ajuste los valores de desviación X e Y para alinear la posición actual %s con la salida del láser de CO2.',
    module_offset_settings_save_failed: 'No se han guardado los ajustes de desviación.',
    moving_laser_head: 'Moviendo el cabezal láser…',
    moving_platform: 'Moviendo la plataforma...',
    next: 'Siguiente',
    no_picture_found: '#846 Su dispositivo no dispone de ninguna foto sin procesar para la calibración. Póngase en contacto con el servicio de asistencia de FLUX.',
    perform_autofocus_bb2: 'Pulse AF en el panel de control de la máquina para realizar el enfoque automático.',
    perform_autofocus_bm2: 'Mueva manualmente el cabezal láser sobre el material y a continuación baje la sonda de enfoque para activar el enfoque automático.',
    please_do_camera_calibration_and_focus: {
      beambox: 'Para calibrar el módulo del diodo láser, se necesita una cámara.\nPor favor, asegúrese de que la cámara de esta máquina ha sido calibrada.\nY ajuste la plataforma al punto focal (la altura del metacrilato dado la vuelta)',
      beamo: 'Para calibrar el módulo del diodo láser, se necesita una cámara.\nPor favor, asegúrese de que la cámara de esta máquina ha sido calibrada\nY ajuste el cabezal láser para enfocar el objeto a grabar (la altura del metacrilato dado la vuelta)',
    },
    please_goto_editor_first: 'Complete la configuración antes de continuar',
    please_place_dark_colored_paper: 'Coloque una hoja de papel oscuro A4 o tamaño carta en el centro del área de trabajo.',
    please_place_paper: 'Coloque una hoja de papel blanco A4 o tamaño carta en la esquina superior izquierda del área de trabajo.',
    please_place_paper_center: 'Coloque una hoja de papel blanco A4 o tamaño carta en el centro del área de trabajo.',
    please_refocus: {
      beambox: 'Por favor, ajuste la plataforma al punto focal (la altura del metacrilato dado la vuelta)',
      beamo: 'Por favor, ajuste el cabezal láser para enfocar el objeto a grabar (la altura del metacrilato dado la vuelta).',
      beamo_af: 'Por favor, pulse dos veces el botón lateral del enfoque automático y deje que la sonda toque suavemente el material.',
      hexa: 'Pulse dos veces en el botón de ajuste de altura para elevar la mesa de nido de abeja y hacer que la sonda toque el material de grabado.',
    },
    preparing_to_take_picture: 'Preparando para tomar foto...',
    promark_help_link: 'https://support.flux3dp.com/hc/en-us/articles/11173605809295',
    put_charuco_promark_2: 'Asegúrese de que el patrón de calibración sea claramente visible sin reflejos. Pulse en "Siguiente" para tomar una foto.',
    put_charuco_promark_desc_1: 'Utilice el papel de calibración incluido en la caja de accesorios o imprima el siguiente archivo en papel A4 para calibrar la cámara.',
    put_charuco_promark_desc_2: 'Coloque el papel de calibración plano y centrado en la plataforma de trabajo.',
    put_chessboard: 'Colocar el tablero de ajedrez',
    put_chessboard_1: 'Pulse AF en el panel de control de la máquina para realizar el enfoque automático.',
    put_chessboard_2: 'Mueva el papel del tablero de ajedrez o el cabezal láser hasta que se confirme que todo el tablero se encuentra dentro del marco rojo de la ventana en vivo de vista previa.',
    put_chessboard_3: 'Pulse el botón derecho para descargar la imagen del tablero en la actual ubicación y compruebe su claridad.',
    put_chessboard_bb2_desc_1: 'Descargue el siguiente archivo del tablero de ajedrez e imprímalo en A4 o formato carta (el tablero impreso ha de tener casillas de 1x1 cm).',
    put_chessboard_bb2_desc_2: 'Fije el papel impreso del tablero a una superficie rígida, como metacrilato o vidrio, asegurándose de que el tablero quede liso y sin arrugas ni levantado.',
    put_chessboard_bb2_desc_3: 'Coloque el tablero plano en el centro del área de trabajo.',
    put_chessboard_bm2_1: 'Imprima el archivo del tablero de ajedrez en A4 (o tamaño carta) para la calibración.',
    put_chessboard_bm2_2: 'Pulse en "Siguiente" y siga las instrucciones para colocar el papel.',
    put_chessboard_promark_1: 'Ajuste la distancia focal al enfoque adecuado de la lente.',
    put_chessboard_promark_2: 'Asegúrese de que el papel cuadriculado se vea claramente sin reflejos. Pulse en "Siguiente" para hacer una foto.',
    put_chessboard_promark_desc_1: 'Utilice el papel cuadriculado que se incluye en la caja de accesorios o imprima el siguiente patrón cuadriculado en A4 para calibrar la cámara.',
    put_chessboard_promark_desc_2: 'Coloque el tablero plano y centrado en la plataforma de trabajo.',
    put_paper: 'Colocar papel',
    put_paper_bm2_1: 'Coloque dos hojas de papel blanco A4 planas y fíjelas.',
    put_paper_bm2_2: 'Baje la sonda de enfoque para enfocar automáticamente el papel.',
    put_paper_bm2_3: 'Cierre la tapa.',
    put_paper_bm2_4: 'Pulse en "Iniciar grabado".',
    put_paper_promark_1: 'Coloque el cartón negro de la caja de accesorios sobre la plataforma de trabajo.',
    put_paper_promark_2: 'Ajuste el enfoque correctamente y a continuación  pulse en "Iniciar grabado" para proceder con el grabado.',
    put_paper_skip: 'Si el dibujo de calibración no pasa automáticamente a la toma de fotografías, pulse en "Omitir" para tomar la fotografía',
    put_paper_step1: 'Coloque una hoja de papel blanco A4 o tamaño carta en el centro del área de trabajo.',
    put_paper_step2: 'Fije las cuatro esquinas del papel para asegurarse de que quede plano.',
    put_paper_step3: 'Pulsar "INICIAR GRABADO".',
    put_paper_wide_angle_1: 'Coloque cuatro hojas planas de papel blanco A4 o tamaño carta para cubrir todo el área de trabajo.',
    put_paper_wide_angle_2: 'Asegure las hojas para que queden planas.',
    relocate_camera: 'Reubicar cámara',
    relocate_camera_desc: 'Si se abre la puerta o se mueve el cabezal láser, reubique la cámara y realinee los puntos.',
    res_average: 'Promedio',
    res_excellent: 'Excelente',
    res_poor: 'Deficiente',
    retake: 'Volver a tomar foto',
    rotation_angle: 'Rotación',
    show_last_config: 'Mostrar el último resultado',
    skip: 'Omitir',
    solve_pnp_bm2: 'Confirme que hay 16 marcas grabadas en los papeles. (Si no es así, pulse en "Atrás" para volver a grabar).',
    solve_pnp_keep_door_closed: 'Mantenga la puerta cerrada durante el proceso.',
    solve_pnp_move_platform: 'La máquina se moverá automáticamente hacia abajo y tomará otra foto. No mueva el papel de calibración durante este proceso.',
    solve_pnp_open_the_lid: 'Por favor, abra la tapa para tomar la foto.',
    solve_pnp_step1: 'Alinee los puntos de grabado según el número y la posición previstos de cada punto marcador rojo.',
    solve_pnp_step2: 'Puede pulsar "Volver a tomar foto" para realinear o ajustar manualmente la posición de los marcadores.',
    solve_pnp_step3: 'Si el punto de grabado está notablemente desviado, arrastre la vista hasta que el punto de grabado sea visible y a continuación pulse en "Volver a tomar foto".',
    solve_pnp_title: 'Alinear puntos de referencia',
    start_engrave: 'Iniciar el grabado',
    start_printing: 'Iniciar la impresión',
    step: 'Paso',
    taking_picture: 'Tomando foto...',
    title_align_marker_points: 'Alinear puntos de referencia',
    title_capture_calibration_pattern: 'Capturar patrón de calibración',
    title_confirm_calibration_result: 'Confirmar resultado de calibración',
    title_engrave_marker_points: 'Puntos de referencia de grabado',
    title_prepare_materials: 'Preparar materiales',
    unable_to_load_camera_parameters: '#851 En su dispositivo no hay parámetros de calibración de la cámara disponibles.\nVaya a "Calibración" > "Calibrar cámara (avanzado)" para completar la calibración y obtener los parámetros.',
    update_firmware_msg1: 'Su firmware no es compatible con esta función. Actualice el firmware a la versión v',
    update_firmware_msg2: 'o superior para continuar (Menú > Máquina > [Su máquina] > Actualizar firmware)',
    uploading_images: 'Cargando imágenes...',
    use_last_config: 'Utilizar el último valor de calibración',
    use_old_camera_parameter: '¿Desea utilizar los parámetros actuales del objetivo de la cámara?',
    with_af: 'Con enfoque automático',
    with_prism_lift: 'Con prisma elevador Ador',
    with_promark_safe_plus: 'Con Promark Safe+',
    without_af: 'Sin enfoque automático',
    without_prism_lift: 'Sin prisma elevador Ador',
    without_promark_safe_plus: 'Sin Promark Safe+',
    x_ratio: 'Relación X',
    y_ratio: 'Relación Y',
    zendesk_link: 'https://support.flux3dp.com/hc/en-us/articles/360001811416',
  },
  camera_data_backup: {
    download_success: 'Datos de la cámara descargados correctamente.',
    downloading_data: 'Descargando datos...',
    estimated_time_left: 'Tiempo estimado restante:',
    folder_not_exists: 'La carpeta seleccionada no existe.',
    incorrect_folder: 'No se han podido cargar los datos de calibración. Compruebe que la carpeta seleccionada es correcta.',
    no_picture_found: 'No se ha encontrado ninguna imagen en la máquina.',
    title: 'Copia de seguridad de datos de la cámara',
    upload_success: 'Datos de la cámara cargados correctamente.',
    uploading_data: 'Cargando datos...',
  },
  caption: {
    connectionTimeout: 'Tiempo de espera de conexión',
  },
  change_logs: {
    added: 'Añadido:',
    change_log: 'Registro de cambios:',
    changed: 'Cambiado:',
    fixed: 'Corregido:',
    help_center_url: 'https://support.flux3dp.com/hc/en-us/sections/360000421876',
    see_older_version: 'Ver versiones anteriores',
  },
  code_generator: {
    barcode: 'Código de barras',
    qr_code: 'Código QR',
  },
  curve_engraving: {
    '921': 'No se ha podido enfocar automáticamente.',
    '922': 'No se ha podido realizar la medición de la luz roja.',
    amount: 'Cantidad',
    apply_arkwork: 'Aplicar diseño en curva',
    apply_camera: 'Aplicar imagen de cámara en curva',
    click_to_select_point: 'Pulsar para seleccionar o deseleccionar puntos para volver a medir.',
    coloumns: 'Columnas',
    column_gap: 'Espacio entre columnas',
    err_object_over_range: 'El objeto excede el rango de medición.',
    failed_to_take_reference: 'No se ha podido tomar la referencia.',
    gap: 'Espacio',
    help_center_url: 'https://support.flux3dp.com/hc/en-us/articles/10364060644495',
    measure_audofocus_area: 'Medir el área de enfoque automático',
    preview_3d_curve: 'Vista previa del grabado de curvas',
    remeasure: 'Volver a medir',
    remeasuring_points: 'Volviendo a medir puntos...',
    reselect_area: 'Volver a seleccionar área',
    row_gap: 'Espacio entre filas',
    rows: 'Filas',
    set_object_height: 'Establecer altura del objeto',
    set_object_height_desc: 'Medir el grosor máximo del objeto.',
    start_autofocus: 'Iniciar enfoque automático',
    starting_measurement: 'Iniciando medición...',
    sure_to_delete: '¿Desea eliminar los datos de enfoque del grabado de la curva?',
    take_reference: 'Tomar referencia',
    take_reference_desc: 'Mueva el cabezal láser al punto más alto del objeto, baje la sonda de enfoque y pulse en "Confirmar" para enfocar.',
  },
  device: {
    abort: 'Cancelar',
    aborted: 'Cancelado',
    aborting: 'Cancelando',
    busy: 'Ocupado',
    cartridge_info_read_failed: 'Asegúrese de que el cartucho esté completamente insertado. Extraiga el cartucho y vuelva a instalarlo.',
    cartridge_info_verification_failed: 'Por favor, comprueba que su tinta sea FLUX original.',
    cartridge_serial_number: 'Número de serie del cartucho de tinta',
    close_door_to_read_cartridge_info: 'Para acceder a la información sobre la tinta, cierre la tapa de la máquina.',
    completed: 'Completado',
    completing: 'Completando',
    deviceList: 'Lista de máquinas',
    disable: 'Deshabilitar',
    disconnectedError: {
      caption: 'Máquina desconectada',
      message: 'Confirme si el acceso a la red de %s está disponible.',
    },
    firmware_version: 'Versión del firmware',
    ink_color: 'Color de tinta',
    ink_level: 'Nivel de tinta',
    ink_type: 'Tipo de tinta',
    IP: 'IP',
    model_name: 'Nombre del modelo',
    occupied: 'Manteniendo',
    pause: 'Pausa',
    paused: 'En pausa',
    pausedFromError: 'Pausado por error',
    pausing: 'Pausando',
    please_wait: 'Por favor, espere...',
    preparing: 'Preparando',
    processing: 'Procesando',
    quit: 'Salir',
    ready: 'Listo',
    reconnecting: 'Reconectando',
    reset: 'Reinicio',
    resuming: 'Reanudando',
    retry: 'Reintentar',
    running: 'Trabajando',
    scanning: 'Escaneo',
    select: 'Seleccionar',
    select_printer: 'Seleccionar impresora',
    serial_number: 'Número de serie',
    start: 'Comenzar',
    starting: 'Comenzando',
    status: 'Estado',
    submodule_type: 'Módulo',
    toolhead_change: 'Cambiar cabezal de herramienta',
    unknown: 'Desconocido',
    uploading: 'Cargando',
    UUID: 'UUID',
  },
  device_selection: {
    go_to_settings: 'Ir a Configuración',
    macos_15_local_network_permission: 'En macOS 15 o posterior, habilite el acceso de Beam Studio a la red local en Configuración del sistema > Privacidad y seguridad > Red local.',
    no_device: '#801 No podemos encontrar su máquina en la red.\nPor favor, siga <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001683556">guía</a> para solucionar el problema de conexión.',
    no_device_web: '#801 Compruebe el estado de su máquina, o a continuación pulse en "Configuración de la máquina" para configurarla.',
    select_usb_device: 'Seleccionar dispositivo USB',
  },
  editor: {
    exposure: 'Brillo',
    nozzle_refresh_area: 'Área de actualización de boquilla',
    opacity: 'Opacidad de vista previa',
    prespray_area: 'Área de Imprimación',
  },
  error_pages: {
    screen_size: 'Tenga en cuenta que Beam Studio puede no funcionar de manera óptima en su dispositivo. Para una experiencia óptima, debe ser un dispositivo con una pantalla con al menos 1.024 píxeles de ancho.',
  },
  flux_id_login: {
    connection_fail: '#847 No se ha podido conectar con el servicio para miembros de FLUX.',
    email: 'Correo electrónico',
    flux_plus: {
      access_monotype_feature: 'No tiene el complemento de fuentes Monotype.',
      access_monotype_feature_note: 'Ha de tener una suscripción FLUX+ Pro o el complemento de fuentes Monotype para acceder a esta función.',
      access_plus_feature_1: 'Está accediendo a',
      access_plus_feature_2: 'característica.',
      access_plus_feature_note: 'Ha de tener una suscripción FLUX+ para acceder a esta función.',
      ai_credit_tooltip: 'Para la eliminación del fondo mediante IA',
      explore_plans: 'Explore los planes FLUX+',
      features: {
        ai_bg_removal: 'Eliminación de fondo mediante IA',
        boxgen: 'Generador de cajas 3D',
        dmkt: 'Más de 1.000 archivos de diseño',
        monotype: 'Más de 250 fuentes Premium',
        my_cloud: 'Almacenamiento ilimitado en la nube',
      },
      flux_credit_tooltip: 'Para archivos de Design Market y eliminación de fondos mediante IA',
      get_addon: 'Obtener complemento',
      goto_member_center: 'Ir al Centro de Miembros',
      learn_more: 'Más información',
      member_center_url: 'https://member.flux3dp.com/en-US/subscription',
      subscribe_now: 'Suscribirse ahora',
      thank_you: '¡Gracias por ser un valioso miembro!',
      website_url: 'https://flux3dp.com/subscription',
    },
    forget_password: '¿Olvidó su contraseña?',
    incorrect: 'La dirección de correo electrónico o la contraseña no son correctas.',
    login: 'Iniciar sesión',
    login_success: 'Sesión iniciada',
    lost_password_url: 'https://id.flux3dp.com/user/forgot-password',
    new_to_flux: '¿Nuevo en FLUX? Cree una cuenta.',
    not_verified: 'La dirección de correo electrónico aún no ha sido verificada.',
    password: 'Contraseña',
    register: 'Cree su cuenta FLUX',
    remember_me: 'Recordar',
    sign_in_later: 'Iniciar sesión más tarde',
    signup_url: 'https://id.flux3dp.com/user/login#up',
    unlock_shape_library: 'Inicie sesión para desbloquear la base de datos de formas.',
  },
  framing: {
    area_check: 'Comprobación de área',
    areacheck_desc: 'Garantiza la seguridad del área de trabajo mediante la vista previa del cuadro delimitador del objeto y la zona de aceleración del cabezal láser.',
    calculating_task: 'Calculando tarea...',
    continuously: 'Continuamente',
    contour: 'Contorno',
    contour_desc: 'Vista previa del contorno real del patrón.',
    framing: 'Enmarcado',
    framing_desc: 'Previsualiza el cuadro delimitador del objeto.',
    hull: 'Envoltura',
    hull_desc: 'Previsualiza una forma que sigue de cerca el diseño, como una banda elástica alrededor del objeto.',
    low_laser: 'Láser bajo',
    low_laser_desc: 'Establezca un valor de baja potencia del láser para la tarea de encuadre.',
    rotate_axis: 'Eje de rotación',
    rotateaxis_desc: 'Vista previa del centro del eje de rotación; el eje en sí no se mueve.',
    rotation_frame_warning: 'La vista previa del marco girará una vez. Evite detenerlo a mitad del proceso para evitar que la posición de marcado se desalinee.',
    rotation_framing_desc: 'Vista previa del rango completo de rotación; el eje gira según la previsualización.',
    start_task: 'Seleccionar carpeta',
    start_task_description: 'Después de completar la vista previa del marco, pulse en "Iniciar tarea" para enviar el trabajo.',
  },
  general: {
    choose_folder: 'Seleccionar carpeta',
    processing: 'Procesando...',
  },
  generators: {
    box_generator: 'Generador de cajas',
    code_generator: 'Generador de código',
    material_test_generator: 'Generador de pruebas de material',
    title: 'Generadores',
  },
  generic_error: {
    OPERATION_ERROR: '[OE] Se ha producido un conflicto de estado, vuelva a intentar la acción.',
    SUBSYSTEM_ERROR: '[SE] Error al ejecutar la tarea en el firmware de la máquina. Reinicie la máquina.',
    UNKNOWN_COMMAND: '[UC] Actualice el firmware del dispositivo.',
    UNKNOWN_ERROR: '[UE] Se ha producido un error desconocido. Reinicie Beam Studio y la máquina.',
  },
  global: {
    apply: 'Aplicar',
    back: 'Volver',
    cancel: 'Cancelar',
    editing: {
      redo: 'Rehacer',
      reset: 'Restablecer',
      reset_view: 'Restablecer Vista',
      undo: 'Deshacer',
      zoom_in: 'Acercar',
      zoom_out: 'Alejar',
    },
    enable: 'Habilitar',
    mode_conflict: 'Esta opción no está disponible en el modo actual.',
    ok: 'De acuerdo',
    preview: 'Vista previa',
    save: 'Guardar',
    save_and_exit: 'Guardar y salir',
    saving: 'Guardando...',
    select: 'Seleccionar',
    stop: 'Detener',
  },
  google_font_panel: {
    all_languages: 'Todos los idiomas',
    category: 'Categoría',
    language_label: 'Idioma',
    language_placeholder: 'Idioma',
    language_unavailable_offline: 'No disponible sin conexión',
    more_google_fonts: 'Más fuentes de Google...',
    no_fonts_available: 'No hay fuentes disponibles.',
    no_internet_connection: 'Sin conexión a Internet',
    no_results_message: 'No se han encontrado fuentes que coincidan con sus criterios de búsqueda.',
    no_selection: 'No se ha seleccionado ninguna fuente',
    offline_message: 'Las fuentes de Google no están disponibles sin conexión. Conéctese a Internet para explorar y seleccionar fuentes de Google.',
    search_placeholder: 'Buscar fuentes...',
    search_unavailable_offline: 'Búsqueda no disponible sin conexión',
    selected_prefix: 'Seleccionada:',
    title: 'Fuentes de Google',
    unavailable_message: 'Las fuentes de Google no están disponibles actualmente. Compruebe su conexión a Internet o póngase en contacto con su administrador.',
  },
  image_edit_panel: {
    eraser: {
      brush_size: 'Tamaño del pincel',
      description: 'Pulse o arrastre para borrar manualmente las áreas no deseadas.',
      title: 'Borrador',
    },
    magic_wand: {
      description: 'Seleccione y elimine áreas adyacentes basadas en la similitud de colores.',
      title: 'Varita mágica',
      tolerance: 'Tolerancia',
    },
    rounded_corner: {
      description: 'Ajusta la redondez de las esquinas del objeto.',
      radius: 'Radio',
      title: 'Esquina redondeada',
    },
    title: 'Editar Imagen',
  },
  initialize: {
    back: 'Volver',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    connect: 'Conectar',
    connect_ethernet: {
      title: 'Conexión directa',
      tutorial1: '1. Conecte la máquina a su ordenador con un cable Ethernet.',
      tutorial2_1: '2. Siga',
      tutorial2_2: 'para convertir tu ordenador en un router.',
      tutorial2_a_href_mac: 'https://support.flux3dp.com/hc/en-us/articles/360001517076',
      tutorial2_a_href_win: 'https://support.flux3dp.com/hc/en-us/articles/360001507715',
      tutorial2_a_text: 'esta guía',
      tutorial3: '3. Pulse en Siguiente.',
    },
    connect_machine_ip: {
      alert: {
        swiftray_connection_error: 'No es posible conectar con el servidor. Reinicie Beam Studio e inténtelo de nuevo.',
      },
      check_camera: 'Comprobando la disponibilidad de la cámara',
      check_connection: 'Comprobando la conexión de la máquina',
      check_firmware: 'Comprobando la versión del firmware',
      check_ip: 'Comprobando la disponibilidad de la IP',
      check_swiftray_connection: 'Comprobando la conexión con el servidor',
      check_swiftray_connection_unreachable: 'servidor inaccesible',
      check_usb: 'Compruebe la conexión USB.',
      connection_failed_hint: 'No se puede conectar con la máquina. Consulte <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001683556">esta guía</a> para solucionar el problema.',
      enter_ip: 'Introduzca la IP de su máquina',
      finish_setting: '¡Comienza a crear!',
      invalid_format: 'Formato inválido',
      invalid_ip: 'IP inválida: ',
      promark_hint: 'Si no consigue conectarse por USB, consulte <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/11318820440591"> artículo del Centro de ayuda</a>.',
      retry: 'Reintentar',
      starts_with_169254: 'Comienza con 169.254',
      succeeded_message: 'Conectado correctamente ð',
      unreachable: 'IP inaccesible',
      unreachable_macos_15: 'En macOS 15 o posterior, habilite el acceso de Beam Studio a la red local en Configuración del sistema > <a target="_blank" href="x-apple.systempreferences:com.apple.preference.security?Privacy_LocalNetwork">Privacidad y seguridad</a> > red local.',
    },
    connect_usb: {
      connect_camera: 'Conecte la cámara de la máquina a su ordenador mediante un cable USB.',
      title: 'Conexión USB',
      title_sub: '(Solo HEXA y Ador)',
      turn_off_machine: 'Apague la máquina.',
      turn_on_machine: 'Encienda la máquina.',
      tutorial1: 'Conecte la máquina a su ordenador mediante el cable USB.',
      tutorial2: "Pulse en 'Siguiente'.",
      wait_for_turning_on: 'es.ts:2616 Pulse en "Siguiente" una vez completado el proceso de inicio y de haber accedido a la pantalla principal.',
    },
    connect_wifi: {
      title: 'Conectando a Wi-Fi',
      tutorial1: '1. Vaya al panel táctil > Pulse en "Red" > "Conectarse a WiFi".',
      tutorial1_ador: '1. Vaya al panel táctil > Pulse en "MÁQUINA" > Pulse "Red" > "Conectarse a WiFi".',
      tutorial2: '2. Selecciona y conecta tu WiFi preferido.',
      what_if_1: '¿Qué pasa si no veo mi WiFi?',
      what_if_1_content: '1. El modo de cifrado de la Wi-Fi debe ser WPA2 o sin contraseña.\n2. El modo de cifrado se puede establecer en la interfaz de administración del router Wi-Fi. Si el router no es compatible con WPA2 enrutador y necesitas ayuda para elegir el router adecuado, ponte en contacto con el servicio de asistencia técnica de FLUX.',
      what_if_2: '¿Qué pasa si no veo ninguna red WiFi?',
      what_if_2_content: '1. Asegúrate de que el dongle Wi-Fi esté completamente conectado.\n2. Si no hay una dirección MAC de la red inalámbrica en la pantalla táctil, por favor contacta con el soporte de FLUX.\n3. El canal Wi-Fi debe ser de 2.4Ghz (5Ghz no es compatible).',
    },
    connect_wired: {
      title: 'Conectando a la red cableada',
      tutorial1: '1. Conecte la máquina a su router.',
      tutorial2: '2. Pulse en Red para obtener la IP de la red cableada.',
      tutorial2_ador: '2. Pulse en MÁQUINA > Red para obtener la IP de la red cableada.',
      what_if_1: '¿Qué pasa si la IP está vacía?',
      what_if_1_content: '1. Asegúrate de que el cable Ethernet esté completamente enchufado.\n2. Si no hay una dirección MAC de la red alámbrica en la pantalla táctil, por favor contacta con el soporte de FLUX.',
      what_if_2: '¿Qué pasa si la IP comienza por 169?',
      what_if_2_content: '1. Si la dirección IP comienza con 169.254, debería ser un problema de configuración de DHCP, por favor contacta a tu ISP (proveedor de servicios de Internet) para mejor asistencia.',
    },
    connecting: 'Conectando...',
    connection_types: {
      ether2ether: 'Conexión directa',
      usb: 'Conexión USB',
      wifi: 'Wi-Fi',
      wired: 'Red cableada',
    },
    next: 'Siguiente',
    no_machine: 'No tengo una máquina ahora.',
    promark: {
      configuration_confirmation: 'Esto garantiza que su Promark esté correctamente configurada para una eficiencia y precisión óptimas.',
      or_complete_later: `O, omite este paso y completa la configuración de Promark más tarde en:
    Máquinas > "Nombre Promark" > Configuración de Promark`,
      qc_instructions: 'Rellene los parámetros que se encuentran en el reverso de la tarjeta QC Pass.',
      select_laser_source: 'Seleccione su Promark',
      select_workarea: 'Selecciona el área de trabajo',
      settings: 'Configuración de Promark',
    },
    retry: 'Reintentar',
    select_beambox: 'Seleccione su Beambox',
    select_beamo: 'Seleccione su beamo',
    select_connection_type: '¿Cómo desea conectarse?',
    select_hexa: 'Seleccione su HEXA',
    select_language: 'Seleccionar el idioma',
    select_machine_type: 'Seleccione el tipo de máquina',
    setting_completed: {
      back: 'Volver',
      great: 'Bienvenido a Beam Studio',
      ok: 'COMENZAR A CREAR',
      setup_later: 'Siempre puede configurar su máquina desde la barra de título > Máquinas > Configuración de la máquina.',
      start: 'Comenzar ',
    },
    skip: 'Saltar',
    start: 'Comenzar',
  },
  input_machine_password: {
    connect: 'CONECTAR',
    password: 'Contraseña',
    require_password: '%s requiere una contraseña.',
  },
  insecure_websocket: {
    extension_detected: 'Se ha detectado la extensión Beam Studio Connect.',
    extension_detected_description: 'Se ha detectado que tiene instalado la extensión Beam Studio Connect. Pulse en Confirmar para redirigirse a HTTPS, o pulse en Cancelar para seguir utilizando HTTP.',
    extension_not_deteced: 'No se ha podido detectar la extensión Beam Studio Connect.',
    extension_not_deteced_description: 'Para utilizar HTTPS, pulse en Confirmar para instalar la extensión Beam Studio Connect. Después de instalarla, actualice la página para activarla.<br/>De lo contrario, pulse en el enlace siguiente para ver cómo utilizar HTTP en Chrome.',
    unsecure_url_help_center_link: '<a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/9935859456271">Enlace</a>',
  },
  layer_module: {
    general_laser: 'Láser',
    laser_2w_infrared: 'Láser infrarrojo de 2 W',
    laser_10w_diode: 'Láser de diodo de 10 W',
    laser_20w_diode: 'Láser de diodo de 20 W',
    non_working_area: 'Área no operativa',
    none: 'Ninguno',
    notification: {
      convertFromLaserModuleMsg: 'Tenga en cuenta que si completa esta operación, la configuración de la capa láser se eliminará y se establecerá de acuerdo con la capa actual.',
      convertFromLaserModuleTitle: '¿Desea convertir el módulo láser en módulo de impresión?',
      convertFromPrintingModuleMsg: 'Tenga en cuenta que si completa esta operación, la configuración del color de la capa de impresión se eliminará y se establecerá de acuerdo con la capa actual.',
      convertFromPrintingModuleTitle: '¿Desea convertir el módulo de impresión en módulo láser?',
      importedDocumentContainsPrinting: 'El documento contiene una capa de impresión, ¿desea cambiar el área de trabajo a Ador?',
      importedDocumentContainsPrinting4C: 'El documento contiene una capa de impresión, ¿desea cambiar el área de trabajo a beamo II?',
      performIRCaliMsg: 'Pulse en Confirmar para ejecutar la calibración, o acceda a la calibración a través del menú superior. <br />(Máquina > [Nombre de su máquina] > Calibrar módulo infrarrojo)',
      performIRCaliTitle: 'Realizar la calibración del módulo infrarrojo.',
      performPrintingCaliMsg: 'Pulse en Confirmar para ejecutar la calibración, o acceda a la calibración a través del menú superior. <br />(Máquina > [Nombre de su máquina] > Calibrar módulo de impresión)',
      performPrintingCaliTitle: 'Realizar la calibración del módulo de impresión.',
      printingLayersConverted: 'Las capas de impresión se han convertido en capas láser.',
    },
    printing: 'Impresión',
    unknown: 'Módulo desconocido',
    uv_print: 'Impresión UV',
    uv_varnish: 'Barniz',
    uv_white_ink: 'Tinta blanca',
  },
  machine_status: {
    '-17': 'Cartridge IO Mode',
    '-10': 'Mantener el modo',
    '-2': 'Escaneando',
    '-1': 'Manteniendo',
    0: 'Inactivo',
    1: 'Iniciando',
    2: 'ST_TRANSFORM',
    4: 'Comenzando',
    6: 'Reanudando',
    16: 'Trabajando',
    18: 'Reanudando',
    32: 'En pausa',
    36: 'En pausa',
    38: 'Pausando',
    48: 'En pausa',
    50: 'Pausando',
    64: 'Completado',
    66: 'Completando',
    68: 'Preparando',
    128: 'Cancelado',
    256: 'Alarma',
    512: 'Fatal',
    UNKNOWN: 'Desconocido',
  },
  material_test_generator: {
    block_settings: 'Configuración del  bloque',
    columns: 'Columnas',
    count: 'Contar',
    cut: 'Cortar',
    engrave: 'Grabar',
    export: 'Exportar',
    max: 'Máx',
    min: 'Mín',
    parameter: 'Parámetro',
    rows: 'Filas',
    size: 'Tamaño (AlxAn)',
    spacing: 'Espaciado',
    table_settings: 'Configuración de la mesa',
    text_settings: 'Configuración del texto',
    title: 'Generador de prueba de material',
  },
  menu: {
    inches: 'Pulgadas',
    mm: 'mm',
  },
  message: {
    auth_error: '#820 Error de autenticación: Actualice Beam Studio y el firmware de la máquina a la última versión.',
    authenticating: 'Autentificando...',
    auto_focus: {
      instruction: 'Mueva el cabezal del módulo láser por encima del objeto y siga las instrucciones animadas para pulsar AF y enfocar.',
      succeeded: 'Enfoque con éxito',
      title: 'Enfoque automático',
      warning_at_coordinates: 'Después de ingresar al modo de enfoque automático, el cabezal láser se reiniciará y se moverá a la posición especificada para enfocar.\nAsegúrese de que la posición objetivo esté en el material y que no haya obstáculos en la ruta de movimiento.',
    },
    backend_calculation: {
      analyzing_svg: 'Analizando SVG - %d%% ...',
      calculating_task_path: 'Calculando ruta de tarea - %d%% ...',
      finishing: 'Finalizando...',
      initializing: 'Inicializando...',
    },
    camera: {
      abort_preview: 'Abortar',
      calibration_wide_angle_camera_first: 'Por favor, calibre primero la cámara gran angular.',
      camera_cable_unstable: 'Se ha detectado que la cámara está transfiriendo fotos de forma inestable. La vista previa se puede seguir realizando con normalidad, pero puede haber problemas de lentitud o tiempo de espera agotado.',
      continue_preview: 'Continuar',
      door_opened: 'Puerta abierta',
      door_opened_text: 'Cierre la puerta antes de reiniciar la vista previa de la cámara.',
      fail_to_transmit_image: '#845 Se ha producido un error en la transmisión de imágenes. Reinicie la máquina o Beam Studio. Si el error persiste, siga las instrucciones de <a target=_blank href=https://flux3dp.zendesk.com/hc/en-us/articles/4402756056079>esta guía</a>.',
      switching_camera: 'Cambiando cámara...',
      ws_closed_unexpectedly: '#844 La conexión a la cámara de la máquina se ha cerrado inesperadamente. Si este error persiste, por favor sigue <a target="_blank" href="https://flux3dp.zendesk.com/hc/en-us/articles/4402755805071">esta guía</a>.',
    },
    cancelling: 'Cancelando...',
    cant_connect_to_device: '#827 No se ha podido conectar la máquina, compruebe su conexión.',
    connected: 'Conectada',
    connecting: 'Conectando...',
    connectingCamera: 'Conectando cámara ...',
    connectingMachine: 'Conectando %s...',
    connectionTimeout: '#805 Tiempo de espera de conexión del dispositivo agotado. Comprueba el estado de su red y el indicador WiFi de su máquina.',
    device_blocked: {
      caption: 'Número de serie no autorizado',
      offline: 'El número de serie de su dispositivo está restringido al uso sin conexión, ya que parece estar desactivado. Facilite el número de la máquina (localizado en su parte posterior) a su distribuidor y pídale que se ponga en contacto con support@flux3dp.com para activar la autorización en línea. Si desea utilizar el dispositivo sin conexión, póngase en contacto directamente con support@flux3dp.com.',
      online: 'El número de serie de su dispositivo parece estar desactivado. Facilite el número de serie de la máquina (localizado en su parte posterior) a su distribuidor y pídale que se ponga en contacto con support@flux3dp.com para activar la autorización del dispositivo.',
    },
    device_busy: {
      caption: 'Maquina ocupada',
      message: 'La máquina está ejecutando otra tarea, inténtelo de nuevo más tarde. Si deja de funcionar, reinicie la máquina.',
    },
    device_is_used: 'La máquina está en uso, ¿desea cancelar la tarea actual?',
    device_not_found: {
      caption: 'No se encuentra la máquina predeterminada.',
      message: '#812 Compruebe el indicador WiFi de su máquina.',
    },
    disconnected: 'Conexión inestable. Compruebe la conexión del dispositivo e inténtelo de nuevo más tarde.',
    endingLineCheckMode: 'Saliendo del modo de comprobación de línea...',
    endingRawMode: 'Saliendo del modo sin procesar...',
    enteringLineCheckMode: 'Entrando en el modo de comprobación de línea...',
    enteringRawMode: 'Entrando en el modo sin procesar...',
    enteringRedLaserMeasureMode: 'Entrando en el modo de medición con láser rojo...',
    exitingRotaryMode: 'Saliendo del modo rotativo ...',
    getProbePosition: 'Obteniendo la posición de la sonda...',
    gettingLaserSpeed: 'Leyendo la velocidad del cabezal láser...',
    homing: 'Volviendo al origen...',
    mac_os_arch_mismatch: {
      caption: 'Reinstalar versión compatible',
      download_center: 'Centro de Descargas',
      message: 'Este Mac usa Apple Silicon. Descargue la versión Apple Silicon y vuelva a instalar.',
    },
    need_password: 'Se necesita contraseña para conectarse a la máquina.',
    please_enter_dpi: 'Introduzca la unidad de medida de su archivo (en mm).',
    preview: {
      adjust: 'Ajustar',
      adjust_height_tooltip: 'Pulse en la casilla de verificación para habilitar la edición.',
      already_performed_auto_focus: '¿Ya ha realizado el enfoque automático, desea utilizar los valores existentes?',
      camera_preview: 'Vista previa de la cámara',
      capturing_image: 'Capturando imagen...',
      enter_manually: 'Introducir manualmente',
      getting_focal_distance: 'Obteniendo distancia focal...',
      moving_to_preview_position: 'Pasando a la posición de vista previa...',
      please_enter_height: 'Introduzca la altura del objeto para capturar una toma precisa con la cámara.',
      please_focus_before_preview: 'Para obtener una mejor calidad de vista previa, realice el enfoque automático antes de previsualizar.',
      press_esc_to_stop: 'Presiona ESC para detener la vista previa de la cámara.',
      succeeded: 'Vista previa con éxito',
    },
    promark_disconnected: '#850 Conexión del dispositivo interrumpida, compruebe el estado de conexión del dispositivo.',
    redLaserTakingReference: 'Tomando referencia...',
    retrievingCameraOffset: 'Leyendo la desviación de la cámara ...',
    settingLaserSpeed: 'Configurando la velocidad del cabezal láser...',
    swiftray_disconnected: 'No se ha podido conectar con el servidor, intentando volver a conectar.',
    swiftray_reconnected: 'El servidor se ha vuelto a conectar, por favor intente volver a enviar el trabajo.',
    time_remaining: 'Tiempo restante:',
    tryingToConenctMachine: 'Intentando conectarse a la máquina...',
    turningOffAirPump: 'Apagado de la bomba de aire ...',
    turningOffFan: 'Apagando el ventilador ...',
    unable_to_find_machine: 'No se ha podido encontrar la máquina ',
    unable_to_start: '#830 Incapaz de comenzar la tarea. Por favor, inténtalo otra vez. Si esto sucede de nuevo, por favor contáctanos con el informe de errores:\n',
    unavailableWorkarea: '#804 El área de trabajo actual excede el área de trabajo de esta máquina. Compruebe el área de trabajo de la máquina seleccionada o configure el área de trabajo en Editar > Configuración del documento.',
    unknown_device: '#826 No se puede conectar a la máquina. Asegúrese de que el cable USB esté conectado a la máquina.',
    unknown_error: '#821 La aplicación ha encontrado un error desconocido. Vaya a Ayuda > Menú > Informe de errores.',
    unsupport_osx_version: 'Es posible que la versión actual %s de macOS no sea compatible con algunas funciones. Por favor, actualice a macOS 13+.',
    unsupport_win_version: 'Es posible que la versión actual %s del sistema operativo no sea compatible con algunas funciones. Por favor, actualice a la última versión.',
    unsupported_example_file: 'El archivo de ejemplo seleccionado no es compatible con el área de trabajo actual.',
    uploading_fcode: 'Cargando FCode',
    usb_unplugged: 'Se ha perdido la conexión USB. Compruebe la conexión.',
    wrong_swiftray_version_message: 'Versión incorrecta del servidor (versión: {versión}). Comprueba si hay varias aplicaciones de Beam Studio en ejecución y cierra las aplicaciones adicionales, antes de volver a intentarlo.',
    wrong_swiftray_version_title: 'Versión incorrecta del servidor',
  },
  monitor: {
    ask_reconnect: 'Se ha perdido la conexión con la máquina. ¿Desea volver a conectarse?',
    bug_report: 'Informe de errores',
    camera: 'Cámara',
    cancel: 'Cancelar',
    confirmFileDelete: '¿Está seguro de que desea eliminar este archivo?',
    connecting: 'Conectando, por favor espere...',
    DEVICE_ERROR: 'Algo salió mal.\nPor favor, reinicia la máquina', // Deprecated in FW 3.3.1
    download: 'Descargar',
    extensionNotSupported: 'Este formato de archivo no es compatible',
    fileExistContinue: 'El archivo ya existe, ¿desea reemplazarlo?',
    forceStop: '¿Desea cancelar la tarea actual?',
    go: 'Comenzar',
    HARDWARE_ERROR_AIR_ASSIST_ABNORMAL: '#913 Sensor de caudal de aire anómalo',
    HARDWARE_ERROR_BOTTOM_OPENED: '#903 Parte inferior abierta. Ciérrela para continuar.',
    HARDWARE_ERROR_COVER_NOT_CLOSED: '#924 No se ha podido instalar la cubierta del cabezal de impresión.',
    HARDWARE_ERROR_COVER_NOT_OPENED: '#925 No se ha podido retirar la cubierta del cabezal de impresión.',
    HARDWARE_ERROR_DOOR_OPENED: '#901 Cierra la puerta para continuar.',
    HARDWARE_ERROR_DRAWER_OPENED: '#911 Cajón abierto',
    HARDWARE_ERROR_FIRE_DETECTED: '#912 Sensor de llama anómalo',
    HARDWARE_ERROR_HEADTYPE_MISMATCH: '#915 Se ha detectado un módulo incorrecto. Instale el módulo correcto para continuar.',
    HARDWARE_ERROR_HEADTYPE_NONE: '#917 Módulo no detectado. Asegúrese de que el módulo esté instalado correctamente para continuar.',
    HARDWARE_ERROR_HEADTYPE_UNKNOWN: '#918 Se ha detectado un módulo desconocido. Instale el módulo correcto para continuar.',
    HARDWARE_ERROR_HOMING_PULLOFF_FAILED: '#920 Error de retorno al punto de origen',
    HARDWARE_ERROR_MAINBOARD_ERROR: '#401 Error crítico: placa base desconectada. Póngase en contacto con el servicio de asistencia de FLUX.', // Deprecated in FW 3.3.1
    HARDWARE_ERROR_OVER_TEMPERATURE: '#902 Sobrecalentamiento. Por favor, espere unos minutos.',
    HARDWARE_ERROR_PLATFORM_HOMING_FAILED: '#910 Fallo en el reinicio del eje Z',
    HARDWARE_ERROR_PRINTER_NO_RESPONSE: '#919 El módulo de impresión no responde.',
    HARDWARE_ERROR_PROBE_SHOWED: 'Por favor, retraiga la sonda.',
    HARDWARE_ERROR_PUMP_ERROR: '#900 Compruebe su depósito de agua.',
    HARDWARE_ERROR_ROTARY_NOT_DETECTED: '#914 No se detectó ningún módulo rotativo.',
    HARDWARE_ERROR_SUBSYSTEM_ERROR: '#402 Error crítico: El subsistema no responde. Póngase en contacto con el servicio de asistencia de FLUX.', // Deprecated in FW 3.3.1
    HARDWARE_FAILURE: 'Algo salió mal.\nPor favor, reinicia la máquina', // Deprecated in FW 3.3.1
    hour: 'tiempo restante',
    left: 'izquierda',
    MAINBOARD_OFFLINE: '#905 Error al conectarse a la placa principal.\nPor favor, reinicia la máquina.',
    minute: 'm',
    monitor: 'MONITOR',
    NO_RESPONSE: '#905 Error al conectarse a la placa principal.\nPor favor, reinicia la máquina.',
    no_task_info: 'Actualmente no hay tareas que mostrar.',
    pause: 'Pausar',
    prepareRelocate: 'Preparándose para la reubicación',
    processing: 'Procesando',
    record: 'Grabar',
    relocate: 'Reubicar',
    RESOURCE_BUSY: 'La máquina está ocupada\nSi no está funcionando, por favor reinicia la máquina.',
    resume: 'Reanudar',
    savingPreview: 'Generando miniaturas',
    second: 's',
    start: 'Comenzar',
    stop: 'Detener',
    SUBSYSTEM_ERROR: '#402 Error crítico: El subsistema no responde. Póngase en contacto con el servicio de asistencia de FLUX.',
    task: {
      BEAMBOX: 'Grabado Láser',
      'N/A': 'Modo libre',
    },
    taskTab: 'Tarea',
    temperature: 'Temperatura',
    upload: 'Cargar',
    USER_OPERATION: 'Por favor, siga las instrucciones en el panel del dispositivo para continuar.',
    USER_OPERATION_CHANGE_CARTRIDGE: 'Por favor, inserte el cartucho correcto para continuar.',
    USER_OPERATION_CHANGE_CARTRIDGE_CARTRIDGE_NOT_DETECTED: 'Por favor, inserte el cartucho para continuar.',
    USER_OPERATION_CHANGE_TOOLHEAD: 'Por favor, instale el módulo correcto para continuar.',
    USER_OPERATION_CHANGE_TOOLHEAD_HEADTYPE_MISMATCH: '#915 Se ha detectado un módulo incorrecto. Por favor, instale el módulo correcto para continuar.',
    USER_OPERATION_CHANGE_TOOLHEAD_HEADTYPE_NONE: '#917 Módulo no detectado. Por favor, asegúrese de que el módulo esté instalado correctamente para continuar.',
    USER_OPERATION_CHANGE_TOOLHEAD_HEADTYPE_UNKNOWN: '#918 Se ha detectado un módulo desconocido. Por favor, instale el módulo correcto para continuar.',
    USER_OPERATION_REMOVE_CARTRIDGE: 'Por favor, retire el cartucho para continuar.',
    USER_OPERATION_ROTARY_PAUSE: 'Por favor, cambie al motor rotativo.',
  },
  my_cloud: {
    action: {
      confirmFileDelete: '¿Está seguro de que desea eliminar este archivo? Esta acción no se puede deshacer.',
      delete: 'Eliminar',
      download: 'Descargar',
      duplicate: 'Duplicar',
      open: 'Abrir',
      rename: 'Renombrar',
    },
    file_limit: 'Archivo gratuito',
    loading_file: 'Cargando...',
    no_file_subtitle: 'Vaya a Menú > Archivo > Guardar en la nube',
    no_file_title: 'Guarde los archivos en My Cloud para empezar.',
    not_login_title: 'Inicie sesión para almacenar sus archivos en la nube.',
    save_file: {
      choose_action: 'Guardar archivo:',
      input_file_name: 'Introducir nombre de archivo:',
      invalid_char: 'Caracteres no válidos:',
      save: 'Guardar',
      save_new: 'Guardar como nuevo archivo',
      storage_limit_exceeded: 'Su almacenamiento en la nube ha alcanzado el límite máximo. Elimine los archivos innecesarios antes de guardar los nuevos.',
    },
    sort: {
      a_to_z: 'Nombre: A - Z',
      most_recent: 'Más reciente',
      oldest: 'Más antiguo',
      z_to_a: 'Nombre: Z - A',
    },
    title: 'My Cloud',
    upgrade: 'Actualizar',
  },
  noun_project_panel: {
    clear: 'Borrar',
    elements: 'Elementos',
    enjoy_shape_library: 'Disfrute de la base de datos de formas.',
    export_svg_title: 'No se puede exportar SVG',
    export_svg_warning: 'Este proyecto contiene objetos protegidos por la ley de propiedad intelectual. Por lo tanto, Beam Studio excluirá automáticamente estos objetos durante la exportación. Aún puede guardar su proyecto en Beam Studio Scene (formato .beam) para conservar todos sus datos. ¿Todavía desea exportar?',
    learn_more: 'Más información',
    login_first: 'Inicie sesión para desbloquear la base de datos de formas.',
    recent: 'Reciente',
    search: 'Buscar',
    shapes: 'Formas',
  },
  pass_through: {
    export: 'Exportar a área de trabajo',
    exporting: 'Exportando,,,',
    guide_mark: 'Marca de guía',
    guide_mark_desc: 'Se grabarán marcas de guía como punto de referencia para alinear el diseño.',
    guide_mark_length: 'Longitud:',
    guide_mark_x: 'Coordenada X:',
    height_desc: 'Establezca la altura de cada sección del área de trabajo.',
    help_links: {
      ado1: 'https://support.flux3dp.com/hc/en-us/articles/10140002160399',
      fbb2: 'https://support.flux3dp.com/hc/en-us/articles/11570021253263',
    },
    help_text: '¿Cómo configurar el paso directo para %(modelo)s?',
    object_length: 'Longitud del objeto',
    ref_layer: 'Capa de referencia',
    ref_layer_desc: 'Tenga en cuenta que la ejecución de la capa de referencia está establecida en 0 por defecto. No se ejecutará, sino que solo servirá como referencia de alineación.',
    ref_layer_name: 'Referencia',
    title: 'Modo de paso directo',
    workarea_height: 'Área de trabajo (alto):',
  },
  promark_connection_test: {
    description: 'El sistema ejecutará una operación de luz roja durante unos 2 min para comprobar si la conexión es estable.',
    health: 'Estabilidad:',
    healthy_description: 'La estabilidad es buena, pero evite mover el ordenador de forma brusca durante el grabado.',
    res_0: 'Excelente',
    res_1: 'Buena',
    res_2: 'Baja',
    res_3: 'Demasiado baja',
    res_4: 'Muy baja',
    restart: 'Reiniciar prueba',
    start: 'Iniciar prueba',
    stop: 'Detener prueba',
    title: 'Prueba de estabilidad de la conexión',
    unhealthy_description: 'La estabilidad es demasiado baja. Se recomienda sustituir el adaptador de red o el cable de alimentación.',
  },
  promark_settings: {
    angle: 'Ángulo',
    bulge: 'Abultamiento',
    field: 'Campo',
    galvo_configuration: 'Configuración Galvo',
    mark: 'Marcado',
    mark_parameters: 'Parámetros de marcado',
    offsetX: 'Desplazamiento X',
    offsetY: 'Desplazamiento Y',
    red_dot: 'Punto rojo',
    scale: 'Escala',
    scaleX: 'Escala X',
    scaleY: 'Escala Y',
    skew: 'Oblicuo',
    switchXY: 'Cambiar X/Y',
    title: 'Configuración de Promark',
    trapezoid: 'Trapezoide',
    workarea_hint: 'Puede cambiar el área de trabajo en Configuración del documento.',
    z_axis_adjustment: {
      section1: 'Ajuste la altura del eje Z para ajustar con precisión el enfoque.',
      title: 'Ajuste del eje Z',
      tooltip1: 'Prueba a marcar un cuadrado de 1x1 cm para confirmar si la actual distancia focal es la adecuada.',
    },
  },
  qr_code_generator: {
    error_tolerance: 'Tolerancia de error',
    error_tolerance_link: 'https://support.flux3dp.com/hc/en-us/articles/9113705072143',
    invert: 'Invertir color de fondo',
    placeholder: 'Introduzca un enlace o texto',
    title: 'Generador de código QR',
  },
  resolution: {
    title: 'Resolución',
    values: {
      detailed: 'Detallado',
      high: 'Alto',
      low: 'Bajo',
      medium: 'Medio',
      ultra: 'Ultra alto',
    },
  },
  rotary_settings: {
    circumference: 'Circunferencia',
    extend_workarea: 'Ampliar área de trabajo',
    mirror: 'Espejo',
    object_diameter: 'Diámetro del objeto',
    overlap_size: 'Tamaño de superposición',
    rotary_scale: 'Escala de rotación',
    split_setting: 'Configuración dividida',
    split_setting_url: 'https://support.flux3dp.com/hc/en-us/articles/12276094010767',
    split_size: 'Tamaño de división',
    type: 'Tipo',
  },
  select_device: {
    auth_failure: '#811 Fallo de autenticación',
    select_device: 'Seleccionar dispositivo',
    unable_to_connect: '#810 No se ha podido establecer una conexión estable con la máquina.',
  },
  settings: {
    anti_aliasing: 'Suavizado',
    auto_connect: 'Seleccionar automáticamente la única máquina',
    auto_switch_tab: 'Cambio automático de capa y panel de objetos',
    autofocus_offset: 'Desplazamiento del enfoque automático',
    autosave_enabled: 'Guardado automático',
    autosave_interval: 'Guardar cada',
    autosave_number: 'Número de guardado automático',
    autosave_path: 'Ubicación de guardado automático',
    autosave_path_not_correct: 'No se ha encontrado la ruta especificada.',
    blade_precut_position: 'Posición de precorte',
    blade_precut_switch: 'Precorte de la cuchilla',
    blade_radius: 'Radio de la cuchilla',
    bottom_up: 'De abajo hacia arriba',
    calculation_optimization: 'Aceleración del cálculo de trayectoria',
    cancel: 'Cancelar',
    caption: 'Ajustes',
    check_updates: 'Comprobación automática',
    close: 'Cerrar',
    confirm_remove_default: 'La máquina predeterminada va a ser eliminada.',
    confirm_reset: '¿Confirma el restablecimiento de Beam Studio?',
    continuous_drawing: 'Dibujo continuo',
    crop_task_thumbnail: 'Miniatura del recorte de contenido',
    crop_task_thumbnail_tooltip: 'Mostrar solo la miniatura del área que contiene contenido, excluyendo las áreas en blanco del lienzo.',
    custom_preview_height: 'Altura de vista previa personalizada',
    default_beambox_model: 'Configuración predeterminada de documentos',
    default_borderless_mode: 'Fondo abierto predeterminado',
    default_enable_autofocus_module: 'Enfoque automático predeterminado',
    default_enable_diode_module: 'Diodo láser predeterminado',
    default_font_family: 'Fuente predeterminada',
    default_font_style: 'Estilo de fuente predeterminada',
    default_laser_module: 'Módulo láser predeterminado',
    default_machine: 'Máquina predeterminada',
    default_machine_button: 'Vacío',
    default_units: 'Unidades por defecto',
    diode_offset: 'Desviación del diodo láser',
    diode_one_way_engraving: 'Grabado unidireccional con diodo láser',
    diode_two_way_warning: 'La emisión de luz bidireccional es más rápida y probablemente genere cierta imprecisión en la posición del grabado láser. Se recomienda probar primero.',
    disabled: 'Deshabilitado',
    done: 'Aplicar',
    enable_custom_backlash: 'Habilitar compensación personalizada de la holgura',
    enable_low_speed: 'Habilitar movimiento a baja velocidad',
    enable_uv_print_file: 'Habilitar archivo de impresión UV',
    enabled: 'Habilitado',
    engraving_direction: 'Dirección',
    engraving_offset_tooltip: 'Si el resultado del grabado se desplaza hacia la izquierda o hacia arriba, reduzca el desplazamiento X/Y; si se desplaza hacia la derecha o hacia abajo, aumente el desplazamiento X/Y.',
    fast_gradient: 'Optimización de la velocidad',
    font_convert: 'Conversor de texto a trayectoria',
    font_substitute: 'Sustituir caracteres no compatibles',
    grouped_objects: 'Objetos agrupados',
    groups: {
      ador_modules: 'Módulos Ador',
      autosave: 'Guardado automático',
      beamo2_modules: 'Módulos beamo 2',
      camera: 'Cámara',
      connection: 'Conexión',
      editor: 'Editor',
      engraving: 'Rasterización (escaneo)',
      general: 'General',
      mask: 'Recorte del área de trabajo',
      module_settings: 'Configuración del módulo',
      module_type: 'Módulo de máquina',
      modules: 'Complemento',
      path: 'Vector (contornos)',
      performance: 'Rendimiento',
      privacy: 'Privacidad',
      text: 'Texto',
      text_to_path: 'Texto',
      update: 'Actualizaciones de software',
      workarea: 'Área de trabajo',
    },
    guess_poke: 'Buscar la dirección IP de la máquina',
    guides: 'Guías',
    guides_origin: 'Origen de guías',
    help_center_urls: {
      anti_aliasing: 'https://support.flux3dp.com/hc/en-us/articles/360004408956',
      calculation_optimization: 'https://support.flux3dp.com/hc/en-us/articles/11146997425039',
      connection: 'https://support.flux3dp.com/hc/en-us/sections/360000302135',
      continuous_drawing: 'https://support.flux3dp.com/hc/en-us/articles/360004406496',
      default_borderless_mode: 'https://support.flux3dp.com/hc/zh-tw/articles/360001104076',
      default_enable_autofocus_module: 'https://support.flux3dp.com/hc/en-us/articles/360001574536',
      default_enable_diode_module: 'https://support.flux3dp.com/hc/en-us/articles/360001568035',
      fast_gradient: 'https://support.flux3dp.com/hc/en-us/articles/360004496235',
      font_convert: 'https://support.flux3dp.com/hc/en-us/articles/9132766761743',
      font_substitute: 'https://support.flux3dp.com/hc/en-us/articles/360004496575',
      image_downsampling: 'https://support.flux3dp.com/hc/en-us/articles/360004494995',
      loop_compensation: 'https://support.flux3dp.com/hc/en-us/articles/360004408856',
      mask: 'https://support.flux3dp.com/hc/en-us/articles/360004408876',
      reverse_engraving: 'https://support.flux3dp.com/hc/en-us/articles/',
      segmented_engraving: 'https://support.flux3dp.com/hc/en-us/articles/12306366019215',
      simplify_clipper_path: 'https://support.flux3dp.com/hc/en-us/articles/360004407276',
      uv_print_export: 'https://support.flux3dp.com/hc/en-us/articles/12320887477135',
      vector_speed_constraint: 'https://support.flux3dp.com/hc/en-us/articles/360004496495',
    },
    high: 'Alto',
    image_downsampling: 'Calidad de vista previa de mapa de bits',
    ip: 'Dirección IP de la máquina',
    keep_preview_result: 'Mantener resultado de vista previa',
    language: 'Idioma',
    loop_compensation: 'Compensación del bucle',
    low: 'Bajo',
    low_laser_for_preview: 'Láser para bastidor móvil',
    mask: 'Recorte del área de trabajo',
    medium: 'Medio',
    module_offset_2w_ir: 'Desplazamiento del láser infrarrojo de 2 W',
    module_offset_10w: 'Desplazamiento del láser de diodo de 10 W',
    module_offset_20w: 'Desplazamiento del láser de diodo de 20 W',
    module_offset_laser: 'Desplazamiento del láser',
    module_offset_printer: 'Desplazamiento de la impresora',
    none: 'Ninguno',
    normal: 'Normal',
    notification_off: 'Desactivado',
    notification_on: 'Activado',
    notifications: 'Notificaciones de escritorio',
    off: 'Desactivado',
    on: 'Activado',
    preview_movement_speed: 'Vista previa de la velocidad de movimiento',
    printer_advanced_mode: 'Modo avanzado de impresión',
    printing_offset_tooltip: 'Si el resultado de impresión se desplaza hacia la izquierda o hacia arriba, reduzca el desplazamiento X/Y; si se desplaza hacia la derecha o hacia abajo, aumente el desplazamiento X/Y.',
    remove_default_machine_button: 'Eliminar',
    reset: 'Reiniciar Beam Studio',
    reset_now: 'Reiniciar Beam Studio',
    segmented_engraving: 'Grabado segmentado',
    share_with_flux: 'Compartir Beam Studio Analytics',
    show_banners: 'Mostrar banner de inicio',
    simplify_clipper_path: 'Optimización de puntos de anclaje',
    single_object: 'Objeto único',
    tabs: {
      device: 'Máquina',
      general: 'General',
    },
    text_path_calc_optimization: 'Optimización del cálculo de trayectoria',
    top_down: 'De arriba hacia abajo',
    trace_output: 'Salida de trazado de imagen',
    update_beta: 'Beta',
    update_latest: 'Último',
    use_real_boundary: 'Utilizar el alcance máximo',
    use_real_boundary_tooltip: 'Expandir al área de trabajo máximo real, sin restricciones por líneas de cuadrícula enteras.',
    use_union_boundary: 'Mostrar área de trabajo superpuesta',
    use_union_boundary_tooltip: 'Mostrar áreas de trabajo superpuestas de varios módulos',
    vector_speed_constraint: 'Límite de velocidad',
    wrong_ip_format: 'Formatos IP incorrectos',
  },
  social_media: {
    facebook: '¡Chatee con los usuarios de FLUX, haga preguntas y aprenda consejos!',
    instagram: '¡Reciba las últimas novedades, ofertas y regalos!',
    youtube: 'Vea los tutoriales e ideas creativas de Beam Studio.',
  },
  stamp_maker_panel: {
    bevel_radius: 'Radio del bisel',
    horizontal_flip: 'Volteo horizontal',
    how_to: {
      text: '¿Cómo hacer un sello?',
      url: 'https://support.flux3dp.com/hc/en-us/articles/13658787903247',
    },
    invert: 'Invertir',
    title: 'Creador de sellos',
  },
  support: {
    no_vcredist: 'Por favor, instale Visual C++ Redistributable 2015. Puede descargarlo en flux3dp.com.',
    no_webgl: 'WebGL no es compatible. Por favor, utilice otros dispositivos.',
  },
  tab_panel: {
    apply: 'Aplicar pestañas',
    gap: 'Espacio',
    help_center: 'https://support.flux3dp.com/hc/en-us/articles/12441363882511',
    manual_mode: 'Modo manual',
    title: 'Pestañas',
    width: 'Ancho',
  },
  topbar: {
    alerts: {
      add_content_first: 'Por favor, añada primero los objetos.',
      close_door_before_framing: 'Cierre la puerta antes de iniciar la vista previa de encuadre.',
      door_opened: 'Cierre la cubierta de la puerta para activar el láser de baja potencia para el bastidor móvil.',
      fail_to_connect_with_camera: '#803 No se ha podido establecer la conexión con la cámara de la máquina. Reinicie su máquina o Beam Studio. Si el error persiste, siga <a target=_blank href=https://flux3dp.zendesk.com/hc/en-us/articles/360001791895>esta guía</a>.',
      fail_to_get_door_status: 'Asegúrese de que la cubierta de la puerta esté cerrada para habilitar el láser de baja potencia para el bastidor móvil.',
      fail_to_start_preview: '#803 No se ha podido iniciar el modo de vista previa. Reinicie su máquina o Beam Studio. Si el error persiste, siga <a target=_blank href=https://flux3dp.zendesk.com/hc/en-us/articles/360001791895>esta guía</a>.',
      headtype_mismatch: 'Se ha detectado un módulo incorrecto',
      headtype_none: 'Módulo no detectado. ',
      headtype_unknown: 'Se ha detectado un módulo desconocido',
      install_correct_headtype: 'Instale correctamente los módulos de diodo láser de 10 W/20 W para habilitar el láser de baja potencia para el bastidor móvil.',
      job_origin_unavailable: 'Para configurar el origen del trabajo se requiere la versión de firmware 4.3.5 / 5.3.5 o superior. ¿Desea actualizar el firmware ahora?',
      job_origin_warning: 'Actualmente está utilizando la «posición actual» como punto de partida. Asegúrese de que el cabezal láser se mueva a la posición correcta para evitar colisiones.',
      object_outside_moving_area: 'Algunos objetos están fuera del área delimitada de la vista previa.',
      power_too_high: 'POTENCIA DEMASIADO ALTA',
      power_too_high_confirm: 'ANOTADO',
      power_too_high_msg: 'Usar una potencia de láser menor (menos del 70%) alargará la vida del tubo láser.\nPulsa "ANOTADO" para proceder.',
      pwm_unavailable: 'El modo de profundidad requiere la versión de firmware 4.3.4 / 5.3.4 o superior. ¿Desea actualizar el firmware ahora?',
      QcleanScene: '¿Quiere borrar el dibujo?<br/>¡Esto borrará también su historial de deshacer!',
      start_preview_timeout: '#803 Se ha producido un tiempo de espera al iniciar el modo de vista previa. Reinicie su máquina o Beam Studio. Si el error persiste, siga <a target=_blank href=https://flux3dp.zendesk.com/hc/en-us/articles/360001791895>esta guía</a>.',
      variable_text_warning: 'Este trabajo contiene texto variable. El sistema dará prioridad al grabado del contenido de texto variable y no seguirá el orden de las capas.',
    },
    frame_task: 'Bastidor móvil',
    hint: {
      polygon: 'Pulse la tecla + / - para aumentar / disminuir los lados.',
    },
    menu: {
      about: 'Acerca de Beam Studio',
      about_beam_studio: 'Acerca de Beam Studio',
      account: 'Cuenta',
      add_new_machine: 'Configuración de la máquina',
      align_center: 'Alinear el centro',
      anti_aliasing: 'Suavizado',
      auto_align: 'Alineación automática',
      autofocus: {
        operating: 'Enfocando automáticamente...',
        select_device_error: 'Seleccione un dispositivo antes del enfoque automático.',
        show_probe_error: 'Muestre la sonda antes del enfoque automático.',
        title: 'Enfoque automático',
      },
      borderless_mode: 'Modo sin bordes',
      bug_report: 'Informe de errores',
      calibrate_beambox_camera: 'Calibrar la cámara',
      calibrate_beambox_camera_borderless: 'Calibrar la cámara (fondo abierto)',
      calibrate_camera_advanced: 'Calibrar la cámara (avanzado)',
      calibrate_diode_module: 'Calibrar el módulo del diodo láser',
      calibrate_ir_module: 'Calibrar el módulo infrarrojo',
      calibrate_printer_module: 'Calibrar el módulo de impresión',
      calibrate_wide_angle_camera: 'Calibrar la cámara (cámara de gran angular)',
      calibration: 'Calibración',
      camera_calibration_data: 'Datos de calibración de la cámara',
      change_logs: 'Registro de cambios',
      clear_scene: 'Nuevo',
      close: 'Cerrar la ventana',
      commands: 'Comandos',
      contact: 'Contáctenos',
      copy: 'Copiar',
      cut: 'Cortar',
      dashboard: 'Panel de control',
      decompose_path: 'Descomponer',
      delete: 'Eliminar',
      design_market: 'Design Market',
      dev_tool: 'Herramienta de depuración',
      disassemble_use: 'Desmontar',
      document_setting: 'Configuración del documento',
      document_setting_short: 'Documento',
      download_data: 'Descargar datos',
      download_log: 'Descargar registros',
      download_log_canceled: 'Descarga del registro cancelada',
      download_log_error: 'Se ha producido un error desconocido. Inténtelo de nuevo más tarde.',
      duplicate: 'Duplicar',
      edit: 'Editar',
      example_files: 'Archivos de ejemplo',
      export_BVG: 'BVG',
      export_flux_task: 'Tarea de FLUX',
      export_JPG: 'JPG',
      export_PNG: 'PNG',
      export_SVG: 'SVG',
      export_to: 'Exportar a...',
      export_UV_print: 'Impresión UV PDF',
      file: 'Archivo',
      fit_to_window: 'Ajustar al tamaño de la ventana',
      follow_us: 'Síganos',
      forum: 'Foro de la comunidad',
      group: 'Agrupar',
      help: 'Ayuda',
      help_center: 'Centro de ayuda',
      hide: 'Ocultar Beam Studio',
      hideothers: 'Ocultar otros',
      image_crop: 'Recorte',
      image_curve: 'Curva',
      image_invert: 'Invertir',
      image_sharpen: 'Afilar',
      image_stamp: 'Biselar',
      image_vectorize: 'Trazar',
      import_acrylic_focus_probe: 'Sonda de enfoque acrílico - 3 mm',
      import_ador_laser_example: 'Ejemplo de Ador Laser',
      import_ador_printing_example_full: 'Ejemplo de impresión Ador - A todo color',
      import_ador_printing_example_single: 'Ejemplo de impresión Ador - Un solo color',
      import_beambox_2_example: 'Ejemplo de Beambox II',
      import_beambox_2_focus_probe: 'Sonda de Enfoque Beambox II - 3 mm',
      import_beamo_2_laser_example: 'Ejemplo de beamo II Laser',
      import_beamo_2_printing_example: 'Ejemplo de impresión beamo II',
      import_hello_beambox: 'Ejemplo de Beambox',
      import_hello_beamo: 'Ejemplo de beamo',
      import_hexa_example: 'Ejemplo de HEXA',
      import_hexa_rf_example: 'Ejemplo de HEXA RF',
      import_material_printing_test: 'Prueba de impresión de material',
      import_material_testing_cut: 'Prueba de corte de material',
      import_material_testing_engrave: 'Prueba de grabado de material',
      import_material_testing_line: 'Prueba de línea de material',
      import_material_testing_old: 'Prueba de grabado de material - clásica',
      import_material_testing_simple_cut: 'Prueba de corte de material - simple',
      import_promark_example: 'Ejemplo de Promark',
      import_promark_mopa_20w_color: 'Prueba de Color MOPA 20 W',
      import_promark_mopa_60w_color: 'Prueba de Color MOPA 60 W',
      import_promark_mopa_100w_color: 'Prueba de Color MOPA 100 W',
      keyboard_shortcuts: 'Atajos de teclado',
      layer_color_config: 'Ajustes de color',
      layer_setting: 'Capa',
      link: {
        beam_studio_api: 'https://github.com/flux3dp/beam-studio/wiki/Beam-Studio-Easy-API',
        contact_us: 'https://flux3dp.zendesk.com/hc/en-us/requests/new',
        design_market: 'https://dmkt.io',
        downloads: 'https://flux3dp.com/downloads/',
        forum: 'https://www.facebook.com/groups/flux.laser/',
        help_center: 'https://helpcenter.flux3dp.com/',
        shortcuts: 'https://support.flux3dp.com/hc/en-us/articles/10003978157455',
      },
      log: {
        camera: 'Cámara',
        cloud: 'Nube',
        discover: 'Descubrir',
        hardware: 'Hardware',
        network: 'Red',
        player: 'Reproductor',
        robot: 'Robot',
        usb: 'USB',
        usblist: 'Lista USB',
      },
      login_or_register: 'Iniciar sesión o registrarse',
      logout: 'Cerrar sesión',
      machine_info: 'Información de la máquina',
      machines: 'Máquinas',
      manage_account: 'Administrar mi cuenta',
      material_test: 'Prueba de material',
      minimize: 'Minimizar',
      my_account: 'Mi cuenta',
      network_testing: 'Probar la configuración de red',
      object: 'Objeto',
      offset: 'Desplazamiento',
      open: 'Abrir',
      paste: 'Pegar',
      paste_in_place: 'Pegar en el lugar',
      path: 'Trayectoria',
      photo_edit: 'Imagen',
      preferences: 'Preferencias',
      promark_color_test: 'Prueba de Color Promark',
      questionnaire: 'Cuestionario de comentarios',
      quit: 'Salir',
      recent: 'Abierto recientemente',
      redo: 'Rehacer',
      reload_app: 'Recargar la aplicación',
      reset: 'Reiniciar',
      rotary_setup: 'Configuración rotativa',
      rotate: 'Girar',
      samples: 'Ejemplos',
      save_as: 'Guardar como...',
      save_scene: 'Guardar',
      save_to_cloud: 'Guardar en la nube',
      scale: 'Escala',
      service: 'Servicios',
      set_as_default: 'Establecido como predeterminado',
      show_gesture_tutorial: 'Introducción a los gestos manuales',
      show_grids: 'Mostrar las cuadrículas',
      show_layer_color: 'Usar el color de la capa',
      show_rulers: 'Mostrar reglas',
      show_start_tutorial: 'Mostrar tutorial de inicio',
      show_ui_intro: 'Mostrar introducción a la interface',
      software_update: 'Actualización del software',
      svg_edit: 'SVG',
      switch_to_beta: 'Cambiar a la versión Beta',
      switch_to_latest: 'Cambiar a versión estable',
      tools: {
        title: 'Herramientas',
      },
      tutorial: 'Iniciar el tutorial de impresión de Delta Family',
      undo: 'Deshacer',
      ungroup: 'Desagrupar',
      update: 'Verificar la actualización',
      update_firmware: 'Actualizar firmware',
      update_machine: 'Actualizar máquina',
      update_mainboard: 'Actualizar placa base',
      update_printer_board: 'Actualizar placa de impresora',
      upload_data: 'Cargar datos',
      using_beam_studio_api: 'Uso de la API de Beam Studio',
      view: 'Vista',
      window: 'Ventana',
      zoom_in: 'Acercar',
      zoom_out: 'Alejar',
      zoom_with_window: 'Ajuste automático del tamaño de la ventana',
    },
    rename_tab: 'Renombrar pestaña',
    select_machine: 'Seleccionar una máquina',
    tag_names: {
      dxf: 'Objeto DXF',
      ellipse: 'Óvalo',
      g: 'Grupo',
      image: 'Imagen',
      line: 'Línea',
      multi_select: 'Múltiples objetos',
      no_selection: 'Sin selección',
      pass_through_object: 'Objeto de paso directo',
      path: 'Trayectoria',
      polygon: 'Polígono',
      rect: 'Rectángulo',
      svg: 'Objeto SVG',
      text: 'Texto',
      text_path: 'Texto en trayectoria',
      use: 'Objeto importado',
    },
    task_preview: 'Previsualizar trayectoria',
    titles: {
      settings: 'Preferencias',
    },
    untitled: 'Sin título',
  },
  topmenu: {
    credit: 'Beam Studio es posible gracias al proyecto de código abierto <a target=_blank href=https://github.com/flux3dp/beam-studio>Beam Studio</a> y a otro <a target=_blank href=https://flux3dp.com/credits/>software de código abierto</a>.',
    device: {
      download_log_canceled: 'Descarga del registro cancelada',
      download_log_error: 'Se ha producido un error desconocido. Inténtelo de nuevo más tarde.',
      log: {
        usblist: 'Lista USB',
      },
      network_test: 'Red de prueba',
    },
    file: {
      all_files: 'Todos los archivos',
      clear_recent: 'Eliminar recientemente abierto',
      converting: 'Convirtiendo en imagen...',
      fcode_files: 'Código FLUX',
      import: 'Importar',
      jpg_files: 'JPG',
      label: 'Archivo',
      path_not_exit: 'Esta ruta ya no parece existir en el disco.',
      png_files: 'PNG',
      save_fcode: 'Exportar tarea de FLUX',
      save_jpg: 'Exportar JPG',
      save_pdf: 'Exportar PDF',
      save_png: 'Exportar PNG',
      save_scene: 'Guardar escena',
      save_svg: 'Exportar SVG',
      scene_files: 'Escena de Beam Studio',
      svg_files: 'SVG',
    },
    version: 'Versión',
  },
  tutorial: {
    ask_retry_calibration: '¿Desea volver a calibrar la cámara?',
    camera_calibration_failed: 'Error en la calibración de la cámara',
    gesture: {
      click: 'Toque para seleccionar el objeto.',
      drag: 'Arrastre para seleccionar los objetos múltiples.',
      hold: 'Mantenga pulsado para abrir el menú contextual.',
      pan: 'Desplace el lienzo con dos dedos.',
      zoom: 'Pellizca con dos dedos para acercar o alejar el lienzo.',
    },
    links: {
      adjust_focus: 'https://flux3dp.zendesk.com/hc/en-us/articles/360001684196',
    },
    look_for_machine: 'Buscando máquina para tutorial...',
    needNewInterfaceTutorial: '¿Desea iniciar un tutorial sobre la nueva interface de Beam Studio?<br/>(puede omitirlo ahora y comenzar más tarde pulsando en Ayuda > Mostrar introducción a la interface).',
    needNewUserTutorial: '¿Desea iniciar un tutorial?<br/>(puede omitirlo ahora y comenzar más tarde pulsando en Ayuda > Mostrar tutorial de inicio).',
    newInterface: {
      add_new_layer: 'Añadir una nueva capa',
      align_controls: 'Controles de alineado',
      basic_shapes: 'Formas básicas',
      camera_preview: 'Vista previa de la cámara',
      drag_to_sort: 'Arrastrar para clasificar',
      end_alert: '¿Estás seguro que quiere finalizar la introducción de la nueva interface de usuario?',
      flip: 'Voltear',
      group_controls: 'Controles de grupo',
      layer_controls: 'Haz clic con el botón derecho del ratón para seleccionar Controles de capa:\nDuplicar / Fusionar / Bloquear / Eliminar Capas',
      object_actions: 'Acciones de objeto',
      pen_tool: 'Herramienta lápiz',
      rename_by_double_click: 'Renombrar mediante doble clic',
      select_image_text: 'Seleccionar / Imagen / Texto',
      select_machine: 'Seleccione una máquina',
      shape_operation: 'Operación de formas',
      start_work: 'Comenzar trabajo',
      switch_between_layer_panel_and_object_panel: 'Cambiar entre panel de capas y panel de objetos',
    },
    newUser: {
      add_new_layer: 'Añadir una nueva capa',
      adjust_focus: '2. Ajustar el foco...',
      close_cover: '3. Cerrar la tapa.',
      drag_to_draw: 'Arrastrar para dibujar',
      draw_a_circle: 'Dibujar un círculo',
      draw_a_rect: 'Dibujar un rectángulo',
      end_alert: '¿Está seguro que desea finalizar el tutorial?',
      end_preview_mode: 'Finalizar modo de vista previa',
      infill: 'Activar el relleno',
      please_select_wood_cutting: 'Por favor, seleccione el ajuste preestablecido Madera - Corte.',
      please_select_wood_engraving: 'Por favor, seleccione el ajuste preestablecido Madera - Grabado.',
      preview_the_platform: 'Vista previa de la plataforma',
      put_wood: '1. Colocar la madera de muestra',
      send_the_file: 'Enviar el archivo',
      set_preset_wood_cut: 'Ajuste preestablecido: Madera - Corte',
      set_preset_wood_engraving: 'Ajuste preestablecido: Madera - Grabado',
      start_tutorial: 'Tutorial de inicio',
      switch_to_layer_panel: 'Cambiar al panel de capas',
      switch_to_object_panel: 'Cambiar al panel de objetos',
      switch_to_preview_mode: 'Cambiar al modo de vista previa',
    },
    next: 'SIGUIENTE',
    retry: 'Reintentar',
    set_connection: 'Establecer conexión',
    skip: 'Omitir',
    skip_tutorial: 'Ha omitido el tutorial. Siempre puede iniciar el tutorial pulsando en Ayuda > Mostrar tutorial de inicio.',
    suggest_calibrate_camera_first: 'Se recomienda a los usuarios que calibren la cámara inicialmente y vuelvan a enfocar antes de cada vista previa para obtener resultados óptimos. <br/>¿Confirma que desea realizar la calibración ahora? <br/>(Puede omitirla ahora y realizarla más tarde pulsando en Menú > Máquina > [Su máquina] > Calibrar cámara).',
    tutorial_complete: 'Esto es todo lo que respecta al tutorial. ¡Ahora es el momento de crear!',
    unable_to_find_machine: 'No se encuentra la máquina para el tutorial. ¿Desea ir a la página de configuración de conexión, volver a intentarlo u omitir el tutorial?',
    welcome: 'BIENVENIDO',
  },
  update: {
    cannot_reach_internet: '#823 No se ha podido acceder al servidor<br/>Compruebe la conexión a Internet.',
    download: 'ACTUALIZACIÓN EN LÍNEA',
    firmware: {
      caption: 'Hay disponible una actualización del firmware de la máquina',
      confirm: 'CARGAR',
      firmware_too_old_update_by_sdcard: 'La versión del firmware es demasiado antigua. Actualice el firmware mediante una tarjeta SD.',
      force_update_message: '#814 Actualice su máquina con la última versión del firmware.',
      latest_firmware: {
        cant_get_latest: 'No se ha podido obtener información sobre el firmware más reciente.',
        caption: 'Actualización del firmware de la máquina',
        message: 'Dispone del último firmware de la máquina',
        still_update: 'ACTUALIZAR',
      },
      message_pattern_1: '%s está listo para la actualización del firmware.',
      message_pattern_2: 'El firmware %s v%s está disponible. Usted tiene v%s.',
      too_old_for_web: 'La versión actual del firmware de su máquina es v%s.\nSi quiere utilizar la versión en línea de Beam Studio,por favor actualice el firmware de la máquina a la última versión .',
      update_fail: '#822 Fallo de actualización',
      update_success: 'Actualización del firmware cargada correctamente.',
      upload_firmware_title: 'Cargar firmware (*.fxfw)',
      upload_mainboard_title: 'Cargar firmware de la placa base (*.bin)',
      upload_printer_board_title: 'Cargar firmware de la placa de la impresora (*.bin)',
    },
    install: 'INSTALAR',
    later: 'MÁS TARDE',
    preparing: 'Preparando...',
    release_note: 'Nota de versión:',
    skip: 'Omitir esta versión',
    software: {
      available_switch: 'Beam Studio v%s está disponible. Tiene v%s. ¿Quiere cambiar a esta versión?',
      available_update: 'Beam Studio v%s está disponible. Tiene v%s. ¿Quiere descargar la actualización?',
      caption: 'Hay disponible una actualización de software para Beam Studio.',
      check_update: 'Comprobar si hay actualizaciones',
      checking: 'Comprobando si hay actualizaciones',
      downloading: 'Descargando actualizaciones en segundo plano, puede pulsar en OK para continuar su trabajo.',
      install_or_not: 'está listo para actualizarse. ¿Desea reiniciar y actualizar ahora?',
      no: 'No',
      no_response: 'No se ha podido conectar al servidor. Compruebe la configuración de red.',
      not_found: 'Está utilizando la última versión de Beam Studio.',
      switch_or_not: 'está listo para el cambio. ¿Desea reiniciar y cambiar ahora?',
      switch_version: 'Cambiar la versión',
      switch_version_not_found: 'No se ha encontrado el cambio de versión',
      update_for_ador: 'La versión actual del software %s es incompatible. Descargue la última versión de Beam Studio para Ador.',
      yes: 'Sí',
    },
    update: 'Actualizar',
    updating: 'Actualizando...',
    upload: 'CARGAR',
  },
  variable_text_settings: {
    advance_by: 'Avanzar por',
    auto_advance: 'Avance automático',
    auto_advance_hint: 'Avanza automáticamente a los siguientes datos variables cada vez que ejecuta un trabajo.',
    bake: 'Finalizar',
    bake_description: 'Eliminar la variabilidad y convertir a texto normal.',
    browse: 'Explorar',
    clear: 'Borrar',
    csv_file: 'Archivo CSV',
    current: 'Actual',
    end: 'Fin',
    failed_to_convert: 'El objeto de texto variable contiene un formato no compatible, lo que puede impedir que se muestre el contenido.',
    file_error: 'No se ha podido analizar el archivo CSV. Compruebe el formato del archivo.',
    file_size_exceeded: 'No se ha podido cargar el archivo. El tamaño del archivo supera los 5 MB.',
    next: 'Siguiente',
    note: 'Esta configuración se aplicará automáticamente a todos los textos variables.',
    previous: 'Anterior',
    start: 'Iniciar',
    test: 'Prueba',
    test_description: 'Mantenga pulsado para ver el texto variable',
    title: 'Configuración de textos variables',
  },
  web_cam: {
    image_to_small: 'El tamaño de la imagen de la cámara es demasiado pequeño. La imagen puede estar dañada.',
    no_device: 'No se ha podido detectar el dispositivo de la cámara. Vuelva a conectar la cámara e inténtelo de nuevo.',
    no_permission: 'Beam Studio no dispone de permisos para acceder a la cámara. Asegúrese de que Beam Studio tiene permiso en la configuración del sistema o del navegador.',
  },
  welcome_page: {
    follow_us: {
      subtitle: '¡Inspírese, aproveche ofertas, consiga regalos y participe con los FLUXers!',
      user_group: 'Grupo de usuarios',
    },
    help_center: {
      guides: 'Guías',
      guides_subtitle: 'Consulte las guías completas de todos los productos FLUX.',
      submit_request: 'Enviar una solicitud',
      subtitle: 'Guías, manuales y recursos de asistencia para todo lo relacionado con FLUX.',
      visit_help_center: 'Visitar el Centro de Ayuda',
    },
    member_center: 'Central de miembros',
    member_center_url: 'https://member.flux3dp.com/en-US/machine-register',
    new_project: 'Nuevo proyecto',
    not_login_placeholder: '¡Consiga créditos gratis de IA al registrarse en una cuenta FLUX!',
    recent_files: 'Archivos recientes',
    shop: 'Tienda',
    shop_products: 'Comprar productos FLUX',
  },
  z_speed_limit_test: {
    alert_before: 'Antes de comenzar el grabado de curvas, el sistema realizará una prueba de carga para evitar la pérdida de pasos debido a un peso excesivo.',
    alert_failed: 'El peso del objeto actual excede el límite de carga para la velocidad actual del eje Z. Reduzca la velocidad del eje Z en el panel de la máquina o sustituya el objeto de grabado antes de volver a realizar la prueba.',
    ignore: 'Ignorar',
    retest: 'Volver a probar',
    testing: 'Realizando prueba de carga...',
  },
};

export default lang;
